// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:36:49.817Z
// Property: Eddison at Deerwood Park (ID: 5134493690101760)
// Collections: 26 amenities, 10 floorplans (live), 33 photos, 80 POIs, 5 reviews, 5 virtual tours, 6 office hours, 1 special offers (live), 18 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5134493690101760",
  "property_external_id": "4717196",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/eddison-at-deerwood-park-jacksonville-fl/g5hql5y",
  "property_google_business_url": "https://www.google.com/maps/place/Eddison+at+Deerwood+Park/@30.2662478,-81.5497323,15z/data=!4m2!3m1!1s0x0:0x7b43a27fc65315db?sa=X&ved=2ahUKEwiw7sHq--H2AhU-omoFHQ18D0kQ_BJ6BAgkEAU",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443209785",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "eddison-at-deerwood-park",
  "property_name": "Eddison at Deerwood Park",
  "property_website_url": "https://www.eddisonatdeerwoodpark.com/",
  "property_domain": "https://www.eddisonatdeerwoodpark.com/",
  "property_address": "4435 Touchton Rd E",
  "property_full_address": "4435 Touchton Rd, Jacksonville, FL 32246",
  "property_address_1": "4435 Touchton Rd",
  "property_address_2": null,
  "property_address_city": "Jacksonville",
  "property_address_state": "FL",
  "property_address_zip_full": "32246-4455",
  "property_address_zip": "32246",
  "property_address_country": "US",
  "property_address_county": "Duval County",
  "property_neighborhood_address": "Windy Hill",
  "property_address_latitude": "30.2629921",
  "property_address_longitude": "-81.54903999999999",
  "property_email": "eddison@alapts.com",
  "property_phone": "(904) 996-0034",
  "property_call_tracking_phone": "904-842-3157",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Modern Southside Jacksonville living starts here.</strong> Explore renovated one-, two-, and three-bedroom apartments with polished finishes, spacious layouts, and everyday convenience—then schedule your tour of Eddison at Deerwood Park.</p>",
  "property_long_description": "<p><strong>Modern Southside Jacksonville living starts here.</strong> At Eddison at Deerwood Park, you get renovated one-, two-, and three-bedroom apartments in the Windy Hill area, close to St. Johns Town Center and everyday routes across the city. Explore <a href=\"/floor-plans\">spacious floor plans</a> with polished touches like stainless steel appliances, built-in microwaves, tile backsplashes, in-home washer and dryer sets, garden tubs, high ceilings with crown molding, and select layouts with patios, balconies, sunrooms, or wood-style flooring.</p><p>Beyond your front door, the community brings a resort-inspired pool, modern fitness center, yoga room, lounge and co-working space, coffee bar, package lockers, outdoor kitchen, car care center, sand volleyball court, dog park, access gates, garages, and storage options together in one convenient setting. From Touchton Road, you’re near Southside Boulevard, J. Turner Butler Boulevard, and I-295, with Tapestry Park dining, IKEA, Topgolf, Touchton Road Park, and the shopping and restaurants of St. Johns Town Center all within easy reach. See more on the <a href=\"/amenities\">amenities</a> and <a href=\"/neighborhood\">neighborhood</a> pages.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019d02ee-e944-742e-9320-1c08a235f63b.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and quartz countertops.",
    "public_id": "019d02ee-e944-742e-9320-1c08a235f63b",
    "storage_key": "property/5134493690101760/019d02ee-e944-742e-9320-1c08a235f63b.webp",
    "width": 1240,
    "height": 827
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "282",
  "property_year_built": "2001",
  "property_year_renovated": "2020",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.90780141843972",
  "property_admin_fee": "250",
  "property_application_fee": "85",
  "property_fees_deposit_info": "Application Fee: $85\nAdministrative Fee: $250\nApplication Approval Fee: Starting at $399",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8472438.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://eddisonatdeerwoodpark.loftliving.com/login",
  "property_apply_now_url": "https://8472438.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e4d7c-cdf2-73ab-9337-1304cc98746c.webp",
  "property_primary_logo_media": {
    "alt_text": "Eddison at Deerwood Park Premier Apartments logo",
    "public_id": "019e4d7c-cdf2-73ab-9337-1304cc98746c",
    "storage_key": "property/5134493690101760/019e4d7c-cdf2-73ab-9337-1304cc98746c.webp",
    "width": 679,
    "height": 266
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e4d7c-8e0c-74f2-b2f2-5dde61d03a73.webp",
  "property_secondary_logo_media": {
    "alt_text": "Eddison logo",
    "public_id": "019e4d7c-8e0c-74f2-b2f2-5dde61d03a73",
    "storage_key": "property/5134493690101760/019e4d7c-8e0c-74f2-b2f2-5dde61d03a73.webp",
    "width": 767,
    "height": 300
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e4d7d-8a2e-7557-895f-253ac14c9237.webp",
  "property_icon_media": {
    "alt_text": "E logo with three green horizontal bars",
    "public_id": "019e4d7d-8a2e-7557-895f-253ac14c9237",
    "storage_key": "property/5134493690101760/019e4d7d-8a2e-7557-895f-253ac14c9237.webp",
    "width": 637,
    "height": 638
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e4d7d-8a2e-7557-895f-253ac14c9237.webp",
  "property_fav_icon_media": {
    "alt_text": "E logo with three green horizontal bars",
    "public_id": "019e4d7d-8a2e-7557-895f-253ac14c9237",
    "storage_key": "property/5134493690101760/019e4d7d-8a2e-7557-895f-253ac14c9237.webp",
    "width": 637,
    "height": 638
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f151a-b50b-743f-bc82-ff73b9de68a6.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f151a-b50b-743f-bc82-ff73b9de68a6",
    "storage_key": "property/5134493690101760/019f151a-b50b-743f-bc82-ff73b9de68a6.webp",
    "width": 679,
    "height": 266
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f151a-aa61-767b-9115-85c94becdecc.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f151a-aa61-767b-9115-85c94becdecc",
    "storage_key": "property/5134493690101760/019f151a-aa61-767b-9115-85c94becdecc.webp",
    "width": 679,
    "height": 266
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#10d562",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#0d0b38",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "711 - 1550",
  "property_sqft_min": "711",
  "property_sqft_max": "1550",
  "property_price_range": "1294 - 2424",
  "property_price_min": "1294",
  "property_price_max": "2424",
  "property_available_units": 20,
  "property_facebook_url": "https://www.facebook.com/EddisonatDeerwoodPark",
  "property_instagram_url": "https://www.instagram.com/eddisondeerwoodparkapts",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJaVX2-W-15YgR2xVTxn-iQ3s",
  "property_youtube_url": "https://www.youtube.com/@EddisonAtDeerwoodPark",
  "property_yelp_url": "https://www.yelp.com/biz/deerwood-park-apartments-jacksonville",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Amenities that keep the day moving.</strong> Recharge in the fitness center and yoga room, settle into the lounge and co-working space, or unwind by the pool, outdoor kitchen, sand volleyball court, and dog park. Everyday extras—package lockers, online resident services, available garages, storage units, and a car care center—add convenience, while in-home laundry, tile backsplashes, USB outlets, crown molding, and select sunrooms or garden tubs bring polish home.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with polish and flexibility.</strong> Explore one-, two-, and three-bedroom apartments at Eddison at Deerwood Park, from streamlined layouts to roomier designs with space to spread out. Renovated finishes may include stainless steel appliances, built-in microwaves, tile backsplashes, in-home washer and dryer sets, and 9-foot ceilings with crown molding, while select homes add a patio or balcony, sunroom, wood-style flooring, or garden tub.</p>",
  "property_home_gallery_blurb": "<p><strong>See Eddison at Deerwood Park in focus.</strong> Browse bright kitchens with stainless steel appliances and tile backsplashes, open living spaces with select balconies or sunrooms, and polished bath details like roomy vanities and garden tubs. The gallery also captures the resort-inspired pool, clubhouse lounge, fitness and yoga spaces, grilling area, sand volleyball, lakeside views, and dog park—so you can picture the community before you tour.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Southside Jacksonville, right within reach.</strong> From Eddison at Deerwood Park, everyday stops and weekend plans are close by—coffee runs, dinner at Tapestry Park, shopping at St. Johns Town Center, and movie nights at Cinemark Tinseltown.</p><p>Touchton Road Park brings a nearby green-space reset, while Southside Boulevard, J. Turner Butler Boulevard, and I-295 connect you to UNF, Deerwood offices, downtown Jacksonville, and the beaches. Explore the map to see what’s around the corner.</p>",
  "property_home_reviews_blurb": "<p><strong>What stands out in the reviews?</strong> Responsive service, fast maintenance, and a community residents describe as clean, quiet, and beautifully maintained. Shoutouts often go to the Eddison at Deerwood Park team for helpful leasing support and quick fixes, while spacious apartments, friendly neighbors, well-kept grounds, and convenient amenities earn repeat praise. See the latest ratings to get a clearer feel for everyday life here.</p>",
  "property_neighborhood_blurb": "<p><strong>Put Southside Jacksonville on your map.</strong> From Eddison at Deerwood Park, Windy Hill places you close to the area’s best mix of errands, dining, green space, and city connections. Start with coffee nearby, catch dinner around Tapestry Park, browse the open-air shops at St. Johns Town Center, or make it a movie night at Cinemark Tinseltown—all without feeling far from home.</p><p>When you want fresh air, Touchton Road Park adds a nearby spot for a quick reset, while Southside Boulevard, J. Turner Butler Boulevard, and I-295 keep UNF, Deerwood offices, downtown Jacksonville, and the beaches within reach. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the location fits your routine.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Start with the spaces that make everyday living easier.</strong> At Eddison at Deerwood Park, your routine can move from a cardio session to the yoga room, a coffee-bar reset, or a poolside afternoon without leaving the community. The lounge and co-working space gives you room to plug in, while package lockers, online resident services, available garages, storage units, and a car care center help handle the practical details. When it’s time to unwind, head for the outdoor kitchen, sand volleyball court, or dog park. Inside your apartment, thoughtful finishes like in-home laundry, built-in microwaves, tile backsplashes, USB outlets, crown molding, and select sunrooms or garden tubs add polish where it counts. Explore more in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_applynow_blurb": "<p><strong>Start your application for modern Southside Jacksonville living.</strong> Choose a renovated one-, two-, or three-bedroom apartment with polished finishes, in-home laundry, and spacious layouts at Eddison at Deerwood Park. When you’re ready to make it yours, begin your online application today.</p>",
  "property_contactus_blurb": "<p><strong>Have questions? We’re here to help.</strong><br>Contact the Eddison at Deerwood Park leasing team to learn more about renovated one-, two-, and three-bedroom apartments, explore availability, or get directions to our Touchton Road community in Southside Jacksonville.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Eddison at Deerwood Park?</strong> Start here for quick answers about renovated apartment living, leasing, amenities, and everyday details. If you need anything else, the leasing team is happy to help—just <a href=\"/contact-us\">reach out</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits your routine.</strong> Choose from one-, two-, and three-bedroom apartments at Eddison at Deerwood Park, with options that range from efficient, easy-to-style spaces to roomier plans with extra separation for work, hosting, or quiet downtime. Inside, renovated finishes bring everyday polish: stainless steel appliances, built-in microwaves, tile backsplashes, in-home washer and dryer sets, and 9-foot ceilings with crown molding in many homes.</p><p>Prefer more light or a little fresh-air space? Select layouts add a patio or balcony, sunroom, wood-style flooring, or a garden tub, so you can compare the details that matter before you choose. Browse current pricing and availability, view photos in the <a href=\"/gallery\">gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite floor plan in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture your day from room to room.</strong> In the Eddison at Deerwood Park photo gallery, you can zoom in on the finishes and spaces that make the community feel polished before you visit. See bright kitchens with stainless steel appliances and tile backsplashes, open living areas that lead toward a balcony or sunroom in select homes, and bathrooms with roomy vanities and garden-tub details.</p><p>Then look beyond the apartment: a resort-inspired pool framed by palms, a clubhouse lounge with oversized windows, fitness and yoga spaces, an outdoor grilling area, sand volleyball, lakeside views, and a dog park. Browse the photos, compare <a href=\"/floor-plans\">available floor plans</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore what’s around Eddison at Deerwood Park.</strong><br>Use the interactive map to view available apartments, get a feel for the Windy Hill location, and see how Touchton Road connects you to shopping, dining, parks, and everyday routes across Southside Jacksonville.</p>",
  "property_pets_blurb": "<p><strong>Bring the paws, not the compromises.</strong> At Eddison at Deerwood Park, cats and dogs have room in the routine, from no-weight-limit apartment living to an on-site dog park made for quick play breaks close to home. After a morning walk through the community, rinse off your car at the car wash, grab a coffee-bar pick-me-up, or settle into a home with practical touches like hard floors, in-home laundry, and select patios, balconies, or sunrooms that make pet life feel easier.</p><p>Need a bigger outing or everyday pet care? This pet-friendly Jacksonville location keeps local vets, pet supplies, and off-leash options within an easy drive. Explore more <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_referafriend_blurb": "<p><strong>Love where you live?</strong> Share Eddison at Deerwood Park with a friend—from renovated <a href=\"/floor-plans\">one-, two-, and three-bedroom apartments</a> to polished finishes and resort-inspired spaces made for everyday ease. Send an invite today and help them find modern Southside Jacksonville living right here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access starts here.</strong><br>Manage life at Eddison at Deerwood Park with a few quick clicks—pay rent, submit maintenance requests, and keep your account up to date, all from one convenient place connected to your modern Southside Jacksonville apartment community.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback from life at Eddison at Deerwood Park.</strong> As you read through the reviews, you’ll see a clear pattern: attentive service, quick maintenance, and a community that residents describe as “clean, quiet, and beautifully maintained.”</p><p>Residents call out team members by name—from Monica and Toran’s responsive support to Enver and George’s fast AC repair and Rob’s helpful leasing experience. Many reviews also highlight spacious apartments, friendly neighbors, well-kept grounds, and amenities that add everyday convenience. Explore the ratings below to see what people appreciate most about calling Eddison at Deerwood Park home.</p>",
  "property_created_at": "1752256260065",
  "property_scheduletour_blurb": "<p><strong>See modern Southside Jacksonville living up close.</strong> Tour renovated one-, two-, and three-bedroom apartments with stainless steel appliances, in-home washer and dryer sets, garden tubs, and select patios, balconies, or sunrooms. Explore the resort-inspired spaces beyond your door, then find the floor plan that fits your day-to-day.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>Our leasing team will follow up soon. In the meantime, picture modern Southside Jacksonville living with renovated one-, two-, and three-bedroom apartments, polished in-home finishes, and convenient community spaces at Eddison at Deerwood Park.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you stop by.</strong> The virtual tours at Eddison at Deerwood Park let you move through the spaces that shape the experience, from a spacious two-bedroom, two-bath apartment to the community areas designed for work, wellness, and downtime. Explore the apartment tour for an easy sense of flow, finish, and everyday function, then continue through the community tour to see how the setting comes together.</p><p>Take a closer look at the fitness center, clubhouse, and media center to picture your routine in motion—workouts, lounge time, game nights, or a quiet reset between errands in Jacksonville. When you’re ready to compare layouts or see more angles, browse <a href=\"/floor-plans\">available floor plans</a>, view the <a href=\"/gallery\">photo gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_copyright": "2025 All Rights Reserved. Eddison at Deerwood Park",
  "property_seo_title_home": "Eddison at Deerwood Park | Apartments in Jacksonville, FL",
  "property_seo_description_home": "Experience the perfect blend of luxury and comfort at Eddison at Deerwood Park in Jacksonville, FL. Choose from spacious one, two, and three-bedroom floor plans designed for modern living. Indulge in resort-style amenities like a refreshing pool, state-of-the-art fitness center, and a serene dog park—ideal for relaxation and recreation. With added conveniences such as smart locks, built-in microwaves, and a cozy coffee bar, your new home awaits. Embrace a lifestyle that caters to your needs, whether you’re enjoying a sunroom with a lake view or hosting friends in our outdoor kitchen. Your new chapter begins here—find your ideal apartment today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Jacksonville, FL",
  "property_seo_description_floorplans": "Unlock the ideal living experience at Eddison at Deerwood Park in Jacksonville, FL. Choose from inviting one, two, or three-bedroom floor plans designed for comfort and style. With spacious layouts and modern amenities, your perfect home awaits. Browse our available apartment homes today and elevate your lifestyle!",
  "property_seo_title_amenities": "Amenities | Jacksonville, FL Apartments for Rent",
  "property_seo_description_amenities": "Experience the perfect blend of comfort and luxury at Eddison at Deerwood Park in Jacksonville, FL. From spacious one, two, and three-bedroom floor plans to an array of resort-style amenities like a scenic lake view, a dog park, and a state-of-the-art fitness center, every detail is designed with your lifestyle in mind. Enjoy contemporary touches such as smart locks, USB outlets, and elegant crown molding. Unwind at our outdoor kitchen or take a refreshing dip in the pool, while community perks like the LUXER package locker and online resident services enhance your living experience. Make Eddison at Deerwood Park your home—the community that elevates everyday living.",
  "property_seo_title_gallery": "Gallery | Apartments in Jacksonville, FL",
  "property_seo_description_gallery": "Experience the vibrant lifestyle at Eddison at Deerwood Park in Jacksonville, FL. With spacious one, two, and three-bedroom floor plans, our community features modern amenities like a state-of-the-art fitness center, refreshing pool, and a serene dog park. Let your imagination run wild as you browse our photo gallery and envision your days spent lounging by the outdoor kitchen or enjoying a game on the volleyball court. Ready to step into your dream home? Picture yourself living here!",
  "property_seo_title_virtualtours": "Virtual Tours | Eddison at Deerwood Park Apartments",
  "property_seo_description_virtualtours": "Step inside Eddison at Deerwood Park, where comfort meets style in Jacksonville, FL. With thoughtfully designed one, two, and three-bedroom floor plans, our community offers a perfect home for everyone. Experience the vibrant lifestyle and upscale amenities – all from the comfort of your screen. Take a virtual tour today and envision your new beginning!",
  "property_seo_title_interactivemap": "Interactive Map | Eddison at Deerwood Park Apartments",
  "property_seo_description_interactivemap": "Unveil your idyllic lifestyle at Eddison at Deerwood Park in Jacksonville, FL, where every floor plan—from cozy one bedrooms to spacious three bedrooms—offers a unique sanctuary. Indulge in luxurious amenities like a refreshing pool, state-of-the-art fitness center, and your pup’s paradise at the dog park. With features such as smart locks, garden tubs, and an outdoor kitchen, every detail is designed for modern living. Navigate your options effortlessly with our interactive community map—your perfect home awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Jacksonville, FL",
  "property_seo_description_neighborhood": "Uncover the vibrant life surrounding Eddison at Deerwood Park in Jacksonville, FL. From cozy one-bedroom retreats to spacious three-bedroom homes, our apartment community is perfectly situated to enjoy local favorites and hidden gems. Dive into the neighborhood atmosphere and check out nearby attractions that make living here truly special. Your next adventure awaits just outside your door!",
  "property_seo_title_contact": "Contact Us | Eddison at Deerwood Park",
  "property_seo_description_contact": "Looking for your ideal home in Jacksonville? At Eddison at Deerwood Park, we offer thoughtfully designed floor plans featuring one, two, and three-bedroom apartments perfect for any lifestyle. Whether you crave cozy simplicity or spacious luxury, our community awaits your call. Have questions? Contact our leasing team today to find out more!",
  "property_seo_title_faqs": "FAQs | Apartments in Jacksonville, FL",
  "property_seo_description_faqs": "Uncover the details that make Eddison at Deerwood Park in Jacksonville, FL, the perfect place to call home. From spacious one, two, and three-bedroom floor plans to an array of amenities like a relaxing pool, fully-equipped fitness center, and a charming dog park, your ideal lifestyle awaits. Have questions? Our FAQs page has the answers you need to make an informed decision about joining our vibrant community. Embrace a new standard of living today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Jacksonville, FL",
  "property_seo_description_reviews": "Experience life at Eddison at Deerwood Park in Jacksonville, FL, where comfort meets luxury! With thoughtfully designed one-, two-, and three-bedroom floor plans, our community offers a lifestyle like no other. Enjoy exclusive amenities including a refreshing pool, dog park, and fully-equipped fitness center, all enhanced by upscale finishes like crown molding and tile backsplashes. Curious about our residents' experiences? Their stories reveal the vibrant, welcoming atmosphere that makes Eddison the perfect place to call home. Check out our resident reviews today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Jacksonville, FL",
  "property_seo_description_applynow": "Welcome to Eddison at Deerwood Park in Jacksonville, FL, where modern comfort meets luxury living. Choose from spacious one, two, and three-bedroom floor plans tailored to your lifestyle. Indulge in premier amenities like a refreshing pool, serene dog park, state-of-the-art fitness center, and a chic coffee bar. With smart locks, garden tubs, and USB outlets, convenience is key. Enjoy the outdoors with our volleyball court and sunlit lounge areas overlooking stunning lake views. Ready to elevate your living experience? Lease your new home online today!",
  "property_seo_title_residentaccess": "Resident Access | Eddison at Deerwood Park",
  "property_seo_description_residentaccess": "Unlock the full potential of your living experience at Eddison at Deerwood Park in Jacksonville, FL. Access your resident portal for convenient rent payments, hassle-free maintenance requests, and essential community updates—all in one place! Your gateway to a seamless lifestyle awaits.",
  "property_seo_title_referafriend": "Refer A Friend | Eddison at Deerwood Park",
  "property_seo_description_referafriend": "\"At Eddison at Deerwood Park in Jacksonville, FL, we believe that great friends make for great neighbors! Share the joy of upscale living by referring a friend to our vibrant community. Together, you can enjoy modern amenities, lush landscapes, and a welcoming atmosphere that feels like home. Start building your dream neighborhood today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Eddison at Deerwood Park",
  "property_seo_description_scheduletour": "Experience modern living at Eddison at Deerwood Park in Jacksonville, FL, where elegance meets comfort in a picturesque setting. Schedule a tour today and envision your new lifestyle among lush landscapes and top-notch amenities!",
  "property_seo_title_privacy": "Privacy Policy | Eddison at Deerwood Park",
  "property_seo_description_privacy": "At Eddison at Deerwood Park in Jacksonville, FL, your privacy matters. Our comprehensive Privacy Policy outlines how we safeguard your personal information while you enjoy our vibrant community. Dive into the details to see how we prioritize your security. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Eddison at Deerwood Park",
  "property_seo_description_accessibility": "\"At Eddison at Deerwood Park in Jacksonville, FL, we champion digital accessibility for all. Join us in fostering an inclusive online experience where everyone can thrive. Your comfort and ease matter—let us guide you through our accessible living community.\"",
  "property_seo_title_sitemap": "Sitemap | Eddison at Deerwood Park",
  "property_seo_description_sitemap": "Unlock the full potential of life at Eddison at Deerwood Park in Jacksonville, FL. Our comprehensive sitemap guides you through our vibrant community of modern apartments, amenities, and local attractions. Navigate your future home with ease—take a closer look today!",
  "property_seo_title_thankyou": "Thank You | Eddison at Deerwood Park",
  "property_seo_description_thankyou": "Thank you for reaching out to Eddison at Deerwood Park! Your interest in our vibrant apartment community in Jacksonville, FL, is appreciated. A dedicated team member will be in touch soon to help you take the next steps toward your new home. Stay tuned for personalized assistance tailored to your needs!",
  "property_seo_title_pets": "Pet Policy | Apartments in Jacksonville, FL\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793651137146",
  "amenities": [
    {
      "id": "custom_13a1c61e-7e74-4d31-8077-0a75ff4d4dbb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_da61b872-6741-466d-8287-dff1fe2b7d9f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_61cb7e86-da80-4d6b-9237-0cc4d9295f40",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood Style Flooring*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1db7f07b-8f77-4ad1-a2d9-068ba049569f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000000641",
      "title": "Garden Tub",
      "amount": "0.0000",
      "description": "Garden Tubs",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b363c62f-3be7-4767-8a76-852a604d08b9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000000698",
      "title": "USB Outlet",
      "amount": "0.0000",
      "description": "USB Outlets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1ba1ff76-38fc-44fb-b4a1-305e688c3381",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Tiled Kitchen Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d364e41b-b087-478f-a626-4a9386c64061",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios and Balconies*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_555520b7-f0bb-4e40-a559-77e861c973be",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000000689",
      "title": "Sunroom",
      "amount": "0.0000",
      "description": "Sunrooms*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3f7aa87b-6875-4c26-bb6a-8c1589d848d0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000000606",
      "title": "Built-In Microwave",
      "amount": "0.0000",
      "description": "Built-In Microwave",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0bb276a8-a608-4c8c-acf2-0b85438a1f7a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000000624",
      "title": "Crown Molding",
      "amount": "0.0000",
      "description": "9' Ceilings w/ Decorative Crown Molding",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_db2c2642-308e-415c-b39b-ba18c44df3c6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cc667ee7-0a14-4df8-9369-c085ea7bb0d8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern Fitness Center w/ Cardio & Strength Room",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8498a5c3-25eb-4dab-9bfe-3252b67e2ef0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Inspired Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b61e8606-b126-4219-b1c8-43a20b3ee680",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000000662",
      "title": "Outdoor Kitchen",
      "amount": "0.0000",
      "description": "Outdoor Kitchen & Grill Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_40b8beb0-3140-4e9d-b0e7-33c8d7c2efee",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000000712",
      "title": "Yoga Room",
      "amount": "0.0000",
      "description": "Zen Yoga Room",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_292bc54e-de60-4cfe-8404-2a21591de356",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Parcel Pending Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0b70c11a-07ac-44cd-b751-fe15f273e668",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000000615",
      "title": "Coffee Bar",
      "amount": "0.0000",
      "description": "Gourmet Coffee Bar",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_777302e4-b65c-45b8-8918-38ba0199f283",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000001372",
      "title": "Lounge",
      "amount": "0.0000",
      "description": "Lounge & Co-Working Space",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_38973f6a-b581-455d-8d94-10b7d96b285d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e1456735-4a89-4a2a-ab43-4fdc9e26a7f1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000000594",
      "title": "Access Gates",
      "amount": "0.0000",
      "description": "Controlled Access Gates",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eb54a5ab-0250-4c9d-a7d0-1675c3f1f15a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000000640",
      "title": "Garages",
      "amount": "0.0000",
      "description": "Garages Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f5548fb8-46e3-458a-94a3-669f70f96a6c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000000611",
      "title": "Car Wash",
      "amount": "0.0000",
      "description": "Community Car Care Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c9f9a7d0-1c08-4a36-bf1e-b885aab718d8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000000701",
      "title": "Volleyball Court",
      "amount": "0.0000",
      "description": "Sand Volleyball Court",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a3bc7a18-07de-4d18-a507-52ed232b3426",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000001292",
      "title": "Storage Units",
      "amount": "0.0000",
      "description": "Storage Units Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1ac75dcf-71c9-4a10-a26e-45a631318dfe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7e918628-23ea-407d-8437-f2e01092642c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_43d72275-ee1e-4456-b039-ef351cf0b38a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
      "image_media": {
        "alt_text": "Living room with a white sofa, green accent wall, and patio access.",
        "public_id": "019f6c0e-5f4c-7533-8538-eb3b9c027602",
        "storage_key": "property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Step into this stylish living room, featuring a comfortable white sofa, a vibrant green accent wall, and direct access to your private patio.",
      "link": "",
      "alt_text": "Living room with a white sofa, green accent wall, and patio access.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4a65771e-36d9-47c5-b5eb-4c07cbb69f78",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8992-1c07-7279-9bc5-6522e870ea46.webp",
      "image_media": {
        "alt_text": "Eddison at Deerwood Park premier apartments monument sign with colorful flowers in foreground.",
        "public_id": "019e8992-1c07-7279-9bc5-6522e870ea46",
        "storage_key": "property/5134493690101760/019e8992-1c07-7279-9bc5-6522e870ea46.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Eddison at Deerwood Park, a premier apartment community. This monument sign greets you with vibrant landscaping.",
      "link": "",
      "alt_text": "Eddison at Deerwood Park premier apartments monument sign with colorful flowers in foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_827c64fe-e233-4f54-859a-d763af977c8a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8992-186c-746e-a320-c77b43050a36.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019e8992-186c-746e-a320-c77b43050a36",
        "storage_key": "property/5134493690101760/019e8992-186c-746e-a320-c77b43050a36.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, surrounded by lush palm trees and comfortable lounge seating.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_642799c0-69a3-4fc8-b787-8fdd339ba0d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8992-1bf9-713b-be70-4c9cc8557f1e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white countertops, stainless steel appliances, and a walk-in pantry with shelves.",
        "public_id": "019e8992-1bf9-713b-be70-4c9cc8557f1e",
        "storage_key": "property/5134493690101760/019e8992-1bf9-713b-be70-4c9cc8557f1e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring white countertops, sleek cabinetry, stainless steel appliances, and a convenient walk-in pantry for ample storage.",
      "link": "",
      "alt_text": "Modern kitchen with white countertops, stainless steel appliances, and a walk-in pantry with shelves.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_243ffec6-6c3c-4f9e-bdaf-c5e2b168a608",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8992-1cab-766e-8ce6-681673badcf9.webp",
      "image_media": {
        "alt_text": "Open concept living, dining, and kitchen area with a large sliding glass door leading to a patio.",
        "public_id": "019e8992-1cab-766e-8ce6-681673badcf9",
        "storage_key": "property/5134493690101760/019e8992-1cab-766e-8ce6-681673badcf9.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Step into this inviting open-concept living space, seamlessly blending the living room, dining area, and kitchen. Enjoy natural light and easy access to outdoor living through the expansive patio doors.",
      "link": "",
      "alt_text": "Open concept living, dining, and kitchen area with a large sliding glass door leading to a patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8c3f4385-ec37-4280-8f46-98e6323e53c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8992-10d7-77fc-8a99-ffc9e01f4ab1.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstand, and doorway to bathroom.",
        "public_id": "019e8992-10d7-77fc-8a99-ffc9e01f4ab1",
        "storage_key": "property/5134493690101760/019e8992-10d7-77fc-8a99-ffc9e01f4ab1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, elegant nightstand with a lamp, and an adjoining bathroom for convenience. A perfect retreat.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstand, and doorway to bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_24eb96d5-b00d-453a-9da4-e94ed58e80ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8992-11b1-722d-8095-3f81542fc3db.webp",
      "image_media": {
        "alt_text": "Community lounge with foosball and shuffleboard tables, and a kitchen area.",
        "public_id": "019e8992-11b1-722d-8095-3f81542fc3db",
        "storage_key": "property/5134493690101760/019e8992-11b1-722d-8095-3f81542fc3db.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a variety of games and entertainment in our community lounge, featuring foosball, shuffleboard, and a full kitchen.",
      "link": "",
      "alt_text": "Community lounge with foosball and shuffleboard tables, and a kitchen area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f1434661-8c93-44a9-aa81-482da614927e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8992-0a66-77bc-89e9-4299d93724ef.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a double vanity, toilet, and bathtub.",
        "public_id": "019e8992-0a66-77bc-89e9-4299d93724ef",
        "storage_key": "property/5134493690101760/019e8992-0a66-77bc-89e9-4299d93724ef.webp",
        "width": 2674,
        "height": 1782
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a large vanity with a quartz countertop, a walk-in closet, and a separate bathtub and shower area.",
      "link": "",
      "alt_text": "Modern bathroom with a double vanity, toilet, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_85f53d4e-f223-47e5-a951-d4f77c588169",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8992-099f-75f3-99ea-af66d73d9217.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with a lake and fountain.",
        "public_id": "019e8992-099f-75f3-99ea-af66d73d9217",
        "storage_key": "property/5134493690101760/019e8992-099f-75f3-99ea-af66d73d9217.webp",
        "width": 2834,
        "height": 1889
      },
      "title": "Community",
      "description": "Experience resort-style living with scenic lake views and lush landscaping. This community offers a peaceful retreat with beautiful outdoor spaces.",
      "link": "",
      "alt_text": "Apartment building exterior with a lake and fountain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6d186f1a-14dc-4213-ab71-ca3b7bffe08b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8991-f805-7779-9d84-617bbbff88e1.webp",
      "image_media": {
        "alt_text": "Open concept living area with a sofa, coffee table, and accent wall.",
        "public_id": "019e8991-f805-7779-9d84-617bbbff88e1",
        "storage_key": "property/5134493690101760/019e8991-f805-7779-9d84-617bbbff88e1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a comfortable sofa, coffee table, and a striking green accent wall. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Open concept living area with a sofa, coffee table, and accent wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_15a560f0-ceb6-4baa-b981-2fb0c926c4ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8992-0047-7347-bba0-3582daa0c3e1.webp",
      "image_media": {
        "alt_text": "Fitness room with yoga mats, weights, and a TV.",
        "public_id": "019e8992-0047-7347-bba0-3582daa0c3e1",
        "storage_key": "property/5134493690101760/019e8992-0047-7347-bba0-3582daa0c3e1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with everything you need for a great workout.",
      "link": "",
      "alt_text": "Fitness room with yoga mats, weights, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8f123023-e80e-4bd9-b2f2-482ed913e435",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8992-00ac-70a1-bd2f-7115cc5f2684.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, quartz countertops, and a large sink.",
        "public_id": "019e8992-00ac-70a1-bd2f-7115cc5f2684",
        "storage_key": "property/5134493690101760/019e8992-00ac-70a1-bd2f-7115cc5f2684.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this spacious and modern kitchen, featuring stainless steel appliances, ample cabinet space, and beautiful quartz countertops. Includes an in-unit washer and dryer for your convenience.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, quartz countertops, and a large sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4aeab13b-ccbc-4d66-addf-e471cd454aa6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8991-f86b-767b-82e4-01c87ea8b28f.webp",
      "image_media": {
        "alt_text": "Spacious lounge area with two green sofas facing each other, a wooden coffee table, and a fireplace.",
        "public_id": "019e8991-f86b-767b-82e4-01c87ea8b28f",
        "storage_key": "property/5134493690101760/019e8991-f86b-767b-82e4-01c87ea8b28f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring comfortable seating and a modern fireplace.",
      "link": "",
      "alt_text": "Spacious lounge area with two green sofas facing each other, a wooden coffee table, and a fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8af2de81-d461-4752-a4f0-dc9c169f8897",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8991-f805-7779-9d84-6422942ae39f.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, tub, and view into bedroom and closet.",
        "public_id": "019e8991-f805-7779-9d84-6422942ae39f",
        "storage_key": "property/5134493690101760/019e8991-f805-7779-9d84-6422942ae39f.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with ample counter space, a separate soaking tub, and a view into the adjacent bedroom and walk-in closet.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity, tub, and view into bedroom and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_da676b8f-e109-4c1c-93a1-d473e976057e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8991-f93e-7205-b405-e73c8ec09ae8.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge seating and palm trees.",
        "public_id": "019e8991-f93e-7205-b405-e73c8ec09ae8",
        "storage_key": "property/5134493690101760/019e8991-f93e-7205-b405-e73c8ec09ae8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our sparkling swimming pool, perfect for relaxing and soaking up the sun. Comfortable lounge seating and lush landscaping create a resort-like atmosphere.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge seating and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5d39ea3f-e8e0-4e86-9c47-79cd0931f21d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8991-ed88-747b-8384-f474756732c7.webp",
      "image_media": {
        "alt_text": "Living room with white sofa, coffee table, and TV.",
        "public_id": "019e8991-ed88-747b-8384-f474756732c7",
        "storage_key": "property/5134493690101760/019e8991-ed88-747b-8384-f474756732c7.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish living room with modern furniture, featuring a comfortable sofa, a unique coffee table, and a wall-mounted TV, perfect for relaxation and entertainment.",
      "link": "",
      "alt_text": "Living room with white sofa, coffee table, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_365510c3-9abf-4cff-b449-0bf2c5282a74",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8991-f3c6-74de-bcd8-1e75137a4797.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with two grills and a bar, surrounded by a paved patio and lush landscaping.",
        "public_id": "019e8991-f3c6-74de-bcd8-1e75137a4797",
        "storage_key": "property/5134493690101760/019e8991-f3c6-74de-bcd8-1e75137a4797.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining with our community's state-of-the-art grilling station and bar area, perfect for gatherings.",
      "link": "",
      "alt_text": "Outdoor grilling area with two grills and a bar, surrounded by a paved patio and lush landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2eeb51b5-d3bd-4f76-9c4d-d0c2300dba4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8991-f05f-71be-9136-e6c5c22b772b.webp",
      "image_media": {
        "alt_text": "Clubhouse with air hockey, foosball, and shuffleboard tables.",
        "public_id": "019e8991-f05f-71be-9136-e6c5c22b772b",
        "storage_key": "property/5134493690101760/019e8991-f05f-71be-9136-e6c5c22b772b.webp",
        "width": 2666,
        "height": 1776
      },
      "title": "Community",
      "description": "Enjoy fun and games in our community clubhouse, complete with air hockey, foosball, and shuffleboard tables.",
      "link": "",
      "alt_text": "Clubhouse with air hockey, foosball, and shuffleboard tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7c7993eb-fc52-4ac5-85b9-93c8dff25ff6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8991-f068-775d-8175-b1e957055251.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, nightstand, dresser, and closet.",
        "public_id": "019e8991-f068-775d-8175-b1e957055251",
        "storage_key": "property/5134493690101760/019e8991-f068-775d-8175-b1e957055251.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen bed, ample storage, and stylish decor.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, nightstand, dresser, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6d09ec86-a783-4677-b0ec-0c9285af13f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8991-dab3-759b-a33a-c4d8b9ac5ec9.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a pergola.",
        "public_id": "019e8991-dab3-759b-a33a-c4d8b9ac5ec9",
        "storage_key": "property/5134493690101760/019e8991-dab3-759b-a33a-c4d8b9ac5ec9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded areas under a pergola.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a58d5a80-e585-4371-9207-c805f9feea39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8991-d8d3-72c1-bf94-93e72f4e0020.webp",
      "image_media": {
        "alt_text": "Spacious living room with white couch, armchair, and balcony access.",
        "public_id": "019e8991-d8d3-72c1-bf94-93e72f4e0020",
        "storage_key": "property/5134493690101760/019e8991-d8d3-72c1-bf94-93e72f4e0020.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this inviting living room featuring a comfortable white sectional, stylish accent chair, and access to your private patio or balcony. Perfect for entertaining or unwinding.",
      "link": "",
      "alt_text": "Spacious living room with white couch, armchair, and balcony access.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_15086f92-8b04-4428-809c-e942d4590230",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8991-d23e-7338-9c31-bd4e994af36e.webp",
      "image_media": {
        "alt_text": "Outdoor dog washing station and fenced dog park area.",
        "public_id": "019e8991-d23e-7338-9c31-bd4e994af36e",
        "storage_key": "property/5134493690101760/019e8991-d23e-7338-9c31-bd4e994af36e.webp",
        "width": 3057,
        "height": 2038
      },
      "title": "Community",
      "description": "Convenient outdoor dog washing station located next to a fenced dog park, perfect for keeping your furry friends clean and happy.",
      "link": "",
      "alt_text": "Outdoor dog washing station and fenced dog park area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_928bda89-332f-4104-852c-590e5b5b8718",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8991-d175-75fd-8d70-6b8749717f42.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and nightstand.",
        "public_id": "019e8991-d175-75fd-8d70-6b8749717f42",
        "storage_key": "property/5134493690101760/019e8991-d175-75fd-8d70-6b8749717f42.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a king-size bed, elegant decor, and ample storage, creating a serene and comfortable living space.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, dresser, and nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dcd16879-55bd-4431-b8b0-560f19e357fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8991-deb6-76fd-b11f-855de433deb0.webp",
      "image_media": {
        "alt_text": "Treadmills, rowing machine, and weight machines in a modern fitness center.",
        "public_id": "019e8991-deb6-76fd-b11f-855de433deb0",
        "storage_key": "property/5134493690101760/019e8991-deb6-76fd-b11f-855de433deb0.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring treadmills, rowing machines, and a variety of weight training equipment for a complete workout.",
      "link": "",
      "alt_text": "Treadmills, rowing machine, and weight machines in a modern fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0523fdb4-1cd7-4f73-a4ea-4abff10ba94f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8991-d79c-722e-83b3-3cf0fcd21eff.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
        "public_id": "019e8991-d79c-722e-83b3-3cf0fcd21eff",
        "storage_key": "property/5134493690101760/019e8991-d79c-722e-83b3-3cf0fcd21eff.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A spacious and modern kitchen featuring stainless steel appliances, ample cabinet space, and elegant countertops. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7a177f7d-0ad3-4a53-a440-248e83cd4f47",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8991-d163-7213-9842-a4f0c4d5aa23.webp",
      "image_media": {
        "alt_text": "Gym with treadmills and elliptical machines",
        "public_id": "019e8991-d163-7213-9842-a4f0c4d5aa23",
        "storage_key": "property/5134493690101760/019e8991-d163-7213-9842-a4f0c4d5aa23.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring treadmills and elliptical machines for a complete workout.",
      "link": "",
      "alt_text": "Gym with treadmills and elliptical machines",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_192872e2-360f-4eb1-94c7-e31ca8b91cd7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8991-d239-7299-b998-a50104e5ecf7.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and pergolas.",
        "public_id": "019e8991-d239-7299-b998-a50104e5ecf7",
        "storage_key": "property/5134493690101760/019e8991-d239-7299-b998-a50104e5ecf7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a relaxing dip in our sparkling swimming pool, complete with comfortable lounge seating and shaded pergolas.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and pergolas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_304ecb62-79e6-4eaf-b619-4ac7569dd9f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8991-d1af-719d-9c71-9b0666fba98a.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with picnic tables and seating.",
        "public_id": "019e8991-d1af-719d-9c71-9b0666fba98a",
        "storage_key": "property/5134493690101760/019e8991-d1af-719d-9c71-9b0666fba98a.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy our outdoor grilling station, complete with picnic tables and bar seating, perfect for al fresco dining.",
      "link": "",
      "alt_text": "Outdoor grilling area with picnic tables and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f8fdb85e-6992-469f-a20d-1fd9e6e17fe7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8991-d1cc-7263-93f3-55aba5fe5921.webp",
      "image_media": {
        "alt_text": "Beach volleyball court and green lawn with palm trees and apartment buildings.",
        "public_id": "019e8991-d1cc-7263-93f3-55aba5fe5921",
        "storage_key": "property/5134493690101760/019e8991-d1cc-7263-93f3-55aba5fe5921.webp",
        "width": 2662,
        "height": 1775
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation at the beach volleyball court, surrounded by lush landscaping and modern apartment buildings. A perfect spot for fun and relaxation.",
      "link": "",
      "alt_text": "Beach volleyball court and green lawn with palm trees and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dde783fc-fbca-43e8-993f-ed72fc911048",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8991-bd9c-77fc-9e1d-baf5f0f263a0.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with modern sofas, a fireplace, and large windows overlooking an outdoor patio.",
        "public_id": "019e8991-bd9c-77fc-9e1d-baf5f0f263a0",
        "storage_key": "property/5134493690101760/019e8991-bd9c-77fc-9e1d-baf5f0f263a0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed lounge, featuring comfortable seating, a cozy fireplace, and stunning views of the courtyard.",
      "link": "",
      "alt_text": "Stylish lounge area with modern sofas, a fireplace, and large windows overlooking an outdoor patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_276c74fe-3a6f-48fb-8008-197d05593bf2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8991-bc2a-71c9-a87a-4a44f80d4df4.webp",
      "image_media": {
        "alt_text": "Laundry room with washer, dryer, and shelving.",
        "public_id": "019e8991-bc2a-71c9-a87a-4a44f80d4df4",
        "storage_key": "property/5134493690101760/019e8991-bc2a-71c9-a87a-4a44f80d4df4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A spacious laundry room featuring a washer, dryer, and ample shelving for storage, offering convenience and organization within the apartment.",
      "link": "",
      "alt_text": "Laundry room with washer, dryer, and shelving.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c3478552-74d7-4c91-ae3d-4e8c28e63f3a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8991-bad1-713b-aff4-8fb6e2e13467.webp",
      "image_media": {
        "alt_text": "Conference room with a large wooden table and chairs, and a separate desk area with office chairs.",
        "public_id": "019e8991-bad1-713b-aff4-8fb6e2e13467",
        "storage_key": "property/5134493690101760/019e8991-bad1-713b-aff4-8fb6e2e13467.webp",
        "width": 2667,
        "height": 1778
      },
      "title": "Community",
      "description": "Host your next meeting or work remotely in our well-appointed conference and business center, featuring comfortable seating and modern amenities.",
      "link": "",
      "alt_text": "Conference room with a large wooden table and chairs, and a separate desk area with office chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_393b22e3-94db-4003-a4c3-3c646f04b49d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e8991-bb2b-7188-ac2c-07e4cbc9e436.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a jacuzzi tub, vanity, and view of a bedroom.",
        "public_id": "019e8991-bb2b-7188-ac2c-07e4cbc9e436",
        "storage_key": "property/5134493690101760/019e8991-bb2b-7188-ac2c-07e4cbc9e436.webp",
        "width": 2678,
        "height": 1787
      },
      "title": "Apartment",
      "description": "Enjoy a relaxing soak in the jacuzzi tub or freshen up at the spacious vanity. This apartment also features a well-appointed bedroom.",
      "link": "",
      "alt_text": "Modern bathroom with a jacuzzi tub, vanity, and view of a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_85465ca1cdf34af8ae29e2ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Deerwood Bistro",
      "poi_type": "Restaurants",
      "poi_address": "8221 Southside Blvd #24, Jacksonville, FL 32256, USA",
      "poi_short_description": "Breakfast and lunch bistro featuring burgers, omelets, soups, sandwiches, salads and hot beverages.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-5334-722d-b1dc-25649d3651fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-5334-722d-b1dc-25649d3651fe",
        "storage_key": "property/5134493690101760/019f150c-5334-722d-b1dc-25649d3651fe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.deerwoodbistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6169251943638007821&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deerwood-bistro",
      "poi_latitude": "30.2195363",
      "poi_longitude": "-81.5507867",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-527-3451",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a6-7329-be2b-bdf879e53035",
        "storage_key": "property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBdVRj_rK5YgRDYBu5vSVnVU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bistro"
    },
    {
      "id": "ec_2e28755c421ef5894048ae4c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "THE LOOP RESTAURANT",
      "poi_type": "Restaurants",
      "poi_address": "8221 Southside Blvd, Jacksonville, FL 32256, USA",
      "poi_short_description": "Outpost of a casual chain serving pizza, plus burgers, shakes & other American favorites.",
      "poi_long_description": "Outpost of a casual chain serving pizza, plus burgers, shakes & other American favorites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-5290-70b2-9c8b-920fe144aaf0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-5290-70b2-9c8b-920fe144aaf0",
        "storage_key": "property/5134493690101760/019f150c-5290-70b2-9c8b-920fe144aaf0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thelooprestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3563881380329407679&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-loop-restaurant",
      "poi_latitude": "30.2201461",
      "poi_longitude": "-81.5508875",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 904-645-7788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a6-7329-be2b-bdf879e53035",
        "storage_key": "property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBdVRj_rK5YgRv8QpsDtzdTE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_d0fe6bb174e7e2c414d219a5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Miller's Ale House",
      "poi_type": "Restaurants",
      "poi_address": "9711 Deer Lake Ct, Jacksonville, FL 32246, USA",
      "poi_short_description": "Casual sports-pub chain with basics from bar snacks to steaks & a large selection of tap beers.",
      "poi_long_description": "Casual sports-pub chain with basics from bar snacks to steaks & a large selection of tap beers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-4dac-752e-82c2-d44c44974b83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-4dac-752e-82c2-d44c44974b83",
        "storage_key": "property/5134493690101760/019f150c-4dac-752e-82c2-d44c44974b83.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://millersalehouse.com/locations/jacksonville-southside/?utm_source=gmb&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=11444725647615948305&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "millers-ale-house",
      "poi_latitude": "30.2657309",
      "poi_longitude": "-81.556386",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 904-565-2882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a6-7329-be2b-bdf879e53035",
        "storage_key": "property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ69vdu3m15YgREXbz-VbV054",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_59ae137ddd2252670fcc6f25",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Cantina Louie (Jacksonville/Southside, FL)",
      "poi_type": "Restaurants",
      "poi_address": "9726 Touchton Rd #105, Jacksonville, FL 32246, USA",
      "poi_short_description": "Mexican restaurant serving favorites such as quesadillas and fajitas, plus margaritas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-4c96-7017-b8e3-de147613b39a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-4c96-7017-b8e3-de147613b39a",
        "storage_key": "property/5134493690101760/019f150c-4c96-7017-b8e3-de147613b39a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://cantinalouie.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10062642732191386311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cantina-louie-jacksonvillesouthside-fl",
      "poi_latitude": "30.2679886",
      "poi_longitude": "-81.55519009999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 904-329-4369",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a6-7329-be2b-bdf879e53035",
        "storage_key": "property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qaQ3e15YgRxwrvMUCwpYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_fe351695067f2a9d4e05e886",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Vagabond Korean BBQ",
      "poi_type": "Restaurants",
      "poi_address": "9726 Touchton Rd Ste 108, Jacksonville, FL 32246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-52c2-744b-a408-e2ed76eee203.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-52c2-744b-a408-e2ed76eee203",
        "storage_key": "property/5134493690101760/019f150c-52c2-744b-a408-e2ed76eee203.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://vagabondkoreansteakhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6338867536191734877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vagabond-korean-bbq",
      "poi_latitude": "30.2678336",
      "poi_longitude": "-81.5551492",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 904-518-5089",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a6-7329-be2b-bdf879e53035",
        "storage_key": "property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZTWbRv215YgRXcT2fHAu-Fc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "korean_barbecue_restaurant"
    },
    {
      "id": "ec_935470d6c70d050c628d0100",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Cooper’s Hawk Winery & Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "4850 Big Island Drive, Jacksonville, FL 32246, USA",
      "poi_short_description": "Upscale chain serving New American fare paired with house-label  wines in a contemporary setting.",
      "poi_long_description": "Upscale chain serving New American fare paired with house-label  wines in a contemporary setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-537c-711f-bd71-83b43bbfe78a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-537c-711f-bd71-83b43bbfe78a",
        "storage_key": "property/5134493690101760/019f150c-537c-711f-bd71-83b43bbfe78a.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://chwinery.com/locations/florida/jacksonville",
      "poi_directions_map_url": "https://maps.google.com/?cid=7584820276312280155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coopers-hawk-winery--restaurant",
      "poi_latitude": "30.2533756",
      "poi_longitude": "-81.5310576",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 904-559-4999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a6-7329-be2b-bdf879e53035",
        "storage_key": "property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJQBDXqfK5YgRWwzG7tqxQmk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_ea86ce5ccc740095ee0b5db3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "The Capital Grille",
      "poi_type": "Restaurants",
      "poi_address": "5197 Big Island Drive, Jacksonville, FL 32246, USA",
      "poi_short_description": "Outpost of the upscale steakhouse chain offers classic American fare & a clubby, refined setting.",
      "poi_long_description": "Outpost of the upscale steakhouse chain offers classic American fare & a clubby, refined setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-4ce2-73d4-8759-a730784653f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-4ce2-73d4-8759-a730784653f1",
        "storage_key": "property/5134493690101760/019f150c-4ce2-73d4-8759-a730784653f1.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.thecapitalgrille.com/locations/fl/jacksonville/jacksonville/8029?cmpid=br:tcg_ag:ie_ch:loc_ca:TCGGMB_sn:gmb_gt:jacksonville-fl-8029_pl:locurl_rd:1025",
      "poi_directions_map_url": "https://maps.google.com/?cid=12551423985689404516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-capital-grille",
      "poi_latitude": "30.2526",
      "poi_longitude": "-81.525537",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 904-997-9233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a6-7329-be2b-bdf879e53035",
        "storage_key": "property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ23sM5KfK5YgRZKRVXJ2dL64",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "ec_5e9b505a63399d03fdc7f8e4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "True Food Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "5205 Big Island Drive, Jacksonville, FL 32246, USA",
      "poi_short_description": "Relaxed, eco-chic chain serving health-conscious fare, including vegan options, plus cocktails.",
      "poi_long_description": "Relaxed, eco-chic chain serving health-conscious fare, including vegan options, plus cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-55eb-77da-ba6c-5d77ef92cb89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-55eb-77da-ba6c-5d77ef92cb89",
        "storage_key": "property/5134493690101760/019f150c-55eb-77da-ba6c-5d77ef92cb89.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.truefoodkitchen.com/locations/jacksonville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3193294371387637149&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "true-food-kitchen",
      "poi_latitude": "30.2525648",
      "poi_longitude": "-81.525044",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 904-996-7333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a6-7329-be2b-bdf879e53035",
        "storage_key": "property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzVqiPKjK5YgRnX3Q3U_cUCw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_2654118366f69333e7e419db",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Maggiano's Little Italy",
      "poi_type": "Restaurants",
      "poi_address": "St. Johns Town Center, 10367 Mid Town Pkwy, Jacksonville, FL 32246, USA",
      "poi_short_description": "Semi-upscale chain for classic Italian fare served family-style in a relaxed, polished space.",
      "poi_long_description": "Semi-upscale chain for classic Italian fare served family-style in a relaxed, polished space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-4bf6-71b0-b66d-da3c7580e28e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-4bf6-71b0-b66d-da3c7580e28e",
        "storage_key": "property/5134493690101760/019f150c-4bf6-71b0-b66d-da3c7580e28e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.maggianos.com/locations/florida/jacksonville/10367-midtown-pkwy/?utm_source=google&utm_medium=organic&utm_campaign=Maggianos",
      "poi_directions_map_url": "https://maps.google.com/?cid=1571101166876324053&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maggianos-little-italy",
      "poi_latitude": "30.2579949",
      "poi_longitude": "-81.525182",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 904-380-4360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a6-7329-be2b-bdf879e53035",
        "storage_key": "property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1_rKPFe15YgR1XDd7S-szRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_783a9f2c864ba62aa11c11ab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "BJ's Restaurant & Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "4907 Gate Pkwy, Jacksonville, FL 32246, USA",
      "poi_short_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_long_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-4bfd-70bb-8f8d-219aeb11df4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-4bfd-70bb-8f8d-219aeb11df4c",
        "storage_key": "property/5134493690101760/019f150c-4bfd-70bb-8f8d-219aeb11df4c.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.bjsrestaurants.com/locations/fl/jacksonville",
      "poi_directions_map_url": "https://maps.google.com/?cid=3674706219497040796&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bjs-restaurant--brewhouse",
      "poi_latitude": "30.2521041",
      "poi_longitude": "-81.53534359999999",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 904-998-0460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a6-7329-be2b-bdf879e53035",
        "storage_key": "property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ08mhJ6LK5YgRnCsKU9Yt_zI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_1f2f7d03ad6d57b927b5eea8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Fuzzy's Taco Shop",
      "poi_type": "Restaurants",
      "poi_address": "8221-1 Southside Blvd, Jacksonville, FL 32256, USA",
      "poi_short_description": "Modern counter-service chain serving Baja-style tacos & other Mexican eats, plus beer & margaritas.",
      "poi_long_description": "Modern counter-service chain serving Baja-style tacos & other Mexican eats, plus beer & margaritas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-564b-7139-906c-4eb4dfbf8acd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-564b-7139-906c-4eb4dfbf8acd",
        "storage_key": "property/5134493690101760/019f150c-564b-7139-906c-4eb4dfbf8acd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://fuzzystacoshop.com/?y_source=1_MjAyMTgzNTYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5479959966602095798&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fuzzys-taco-shop",
      "poi_latitude": "30.2204026",
      "poi_longitude": "-81.55081779999999",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-374-3402",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a6-7329-be2b-bdf879e53035",
        "storage_key": "property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE860lN7L5YgRtuytOI66DEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "ec_8767764c0064c99c53dd51db",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Deerwood Bistro",
      "poi_type": "Restaurants",
      "poi_address": "8221 Southside Blvd #24, Jacksonville, FL 32256, USA",
      "poi_short_description": "Breakfast and lunch bistro featuring burgers, omelets, soups, sandwiches, salads and hot beverages.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-59bd-73b9-90a8-31e0278dd4a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-59bd-73b9-90a8-31e0278dd4a5",
        "storage_key": "property/5134493690101760/019f150c-59bd-73b9-90a8-31e0278dd4a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.deerwoodbistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6169251943638007821&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deerwood-bistro",
      "poi_latitude": "30.2195363",
      "poi_longitude": "-81.5507867",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-527-3451",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a6-7329-be2b-bdf879e53035",
        "storage_key": "property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBdVRj_rK5YgRDYBu5vSVnVU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bistro"
    },
    {
      "id": "ec_599641b826b10224b9f7f0a9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "4804 E Deer Lake Dr, Jacksonville, FL 32246, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-5960-757d-be3d-dc6444bec417.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-5960-757d-be3d-dc6444bec417",
        "storage_key": "property/5134493690101760/019f150c-5960-757d-be3d-dc6444bec417.webp",
        "width": 1280,
        "height": 1136
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/89108/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11718686611310593161&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "30.26031",
      "poi_longitude": "-81.55421",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 904-645-5119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-a266-72af-88aa-ec57b32bfd7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-a266-72af-88aa-ec57b32bfd7b",
        "storage_key": "property/5134493690101760/019f150c-a266-72af-88aa-ec57b32bfd7b.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ-QpyqH615YgRiURLfWIjoaI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_005d3a95bfe2c9d5d807d244",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Firehouse Subs Deerwood",
      "poi_type": "Restaurants",
      "poi_address": "8221 Southside Blvd #4, Jacksonville, FL 32256, USA",
      "poi_short_description": "Counter-serve sandwich chain offering made-to-order hot & cold subs, plus a variety of hot sauces.",
      "poi_long_description": "Counter-serve sandwich chain offering made-to-order hot & cold subs, plus a variety of hot sauces.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-5a7d-722b-b338-a011b32a57c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-5a7d-722b-b338-a011b32a57c4",
        "storage_key": "property/5134493690101760/019f150c-5a7d-722b-b338-a011b32a57c4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.firehousesubs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13354331591301586802&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "firehouse-subs-deerwood",
      "poi_latitude": "30.220222",
      "poi_longitude": "-81.550964",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 904-996-0894",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a6-7329-be2b-bdf879e53035",
        "storage_key": "property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBdVRj_rK5YgRct9O-NMdVLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "ec_47a7bd2d5f7b31cf486cc604",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Publix Super Market at St. John's Town Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "4413 Town Center Pkwy #100, Jacksonville, FL 32246, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-5a2a-7392-8df0-7aa3a9811882.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-5a2a-7392-8df0-7aa3a9811882",
        "storage_key": "property/5134493690101760/019f150c-5a2a-7392-8df0-7aa3a9811882.webp",
        "width": 1280,
        "height": 724
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1125&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=17040965378156256864&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-st-johns-town-center",
      "poi_latitude": "30.264259",
      "poi_longitude": "-81.5264602",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 904-564-3632",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d662-7177-bfa0-269f4be667aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d662-7177-bfa0-269f4be667aa",
        "storage_key": "property/5134493690101760/019f150a-d662-7177-bfa0-269f4be667aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLZsOUUW15YgRYN67ermrfew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_6660786d984d60dbe6cf3756",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "4873 Town Center Pkwy, Jacksonville, FL 32246, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-5faf-73e3-898e-7f2b3596a8f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-5faf-73e3-898e-7f2b3596a8f6",
        "storage_key": "property/5134493690101760/019f150c-5faf-73e3-898e-7f2b3596a8f6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.sprouts.com/store/fl/jacksonville/jacksonville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10843470373981815027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "30.2537444",
      "poi_longitude": "-81.533397",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 904-438-7840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d662-7177-bfa0-269f4be667aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d662-7177-bfa0-269f4be667aa",
        "storage_key": "property/5134493690101760/019f150a-d662-7177-bfa0-269f4be667aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUdn4KcHL5YgR84Condq-e5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_e4d394078577fa79219e931c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "4901 Gate Pkwy #357b, Jacksonville, FL 32246, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-5e6e-70ba-a950-4c75b4c0f197.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-5e6e-70ba-a950-4c75b4c0f197",
        "storage_key": "property/5134493690101760/019f150c-5e6e-70ba-a950-4c75b4c0f197.webp",
        "width": 1280,
        "height": 957
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/jacksonville-FL-357.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=4318056365048931736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "30.2516046",
      "poi_longitude": "-81.5334151",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 904-997-7003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d670-723f-810a-20de45a1008a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d670-723f-810a-20de45a1008a",
        "storage_key": "property/5134493690101760/019f150a-d670-723f-810a-20de45a1008a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnUML6aDK5YgRmCXbzmLR7Ds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "ec_ff2ad3d6b95328348ab982a4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "4893 Town Center Pkwy, Jacksonville, FL 32246, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-5e7d-7756-9ce5-8906153d3e17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-5e7d-7756-9ce5-8906153d3e17",
        "storage_key": "property/5134493690101760/019f150c-5e7d-7756-9ce5-8906153d3e17.webp",
        "width": 1280,
        "height": 987
      },
      "poi_business_url": "https://www.cvs.com/store-locator/jacksonville-fl-pharmacies/4893-town-center-parkway-jacksonville-fl-32246/storeid=8902?WT.mc_id=LS_GOOGLE_FS_8902",
      "poi_directions_map_url": "https://maps.google.com/?cid=15665363148135295600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "30.2541482",
      "poi_longitude": "-81.5353868",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 904-642-2442",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66c-76fc-8edd-939ac8d3841e",
        "storage_key": "property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn4Vl8Vi15YgRcGoZ2siMZtk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_75a1720e154b328d1701cd6b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Wawa",
      "poi_type": "Shopping & Retail",
      "poi_address": "4866 Gate Pkwy, Jacksonville, FL 32246, USA",
      "poi_short_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_long_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-5e6e-70ba-a950-4909ca185a3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-5e6e-70ba-a950-4909ca185a3a",
        "storage_key": "property/5134493690101760/019f150c-5e6e-70ba-a950-4909ca185a3a.webp",
        "width": 500,
        "height": 400
      },
      "poi_business_url": "https://www.wawa.com/locations/5257?utm_source=gmblisting&utm_medium=organic&utm_campaign=locallisting",
      "poi_directions_map_url": "https://maps.google.com/?cid=15749704394058546376&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wawa",
      "poi_latitude": "30.2537166",
      "poi_longitude": "-81.5366715",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 904-900-7690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a6-7329-be2b-bdf879e53035",
        "storage_key": "property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh9P3CaDK5YgRyLxEbbMwkto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_f69f3780846be5c3b7f6e58e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "St. Johns Town Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "4663 River City Dr, Jacksonville, FL 32246, USA",
      "poi_short_description": "Outdoor mall with known fashion, home goods & electronics brands, sit-down dining & quick snacks.",
      "poi_long_description": "Outdoor mall with known fashion, home goods & electronics brands, sit-down dining & quick snacks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f1509-fb32-777d-b9b3-562408f97fe2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-fb32-777d-b9b3-562408f97fe2",
        "storage_key": "property/5134493690101760/019f1509-fb32-777d-b9b3-562408f97fe2.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.simon.com/mall/st-johns-town-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=18063775443598808474&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-johns-town-center",
      "poi_latitude": "30.2568706",
      "poi_longitude": "-81.5253244",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 904-998-7156",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d670-723f-810a-20de45a1008a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d670-723f-810a-20de45a1008a",
        "storage_key": "property/5134493690101760/019f150a-d670-723f-810a-20de45a1008a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJFX_HOVe15YgRmpUhWg9sr_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_1ead521e5336a85b762883b0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "4567 River City Dr, Jacksonville, FL 32246, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-606f-729b-9d6b-05f88792fa99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-606f-729b-9d6b-05f88792fa99",
        "storage_key": "property/5134493690101760/019f150c-606f-729b-9d6b-05f88792fa99.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/jacksonville-st-johns/1974",
      "poi_directions_map_url": "https://maps.google.com/?cid=17370927936033891123&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "30.260905",
      "poi_longitude": "-81.524412",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 904-596-0020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d670-723f-810a-20de45a1008a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d670-723f-810a-20de45a1008a",
        "storage_key": "property/5134493690101760/019f150a-d670-723f-810a-20de45a1008a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJbj0P1e15YgRM6M1NuzuEfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_5889787db9036d266698d32a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "IKEA",
      "poi_type": "Shopping & Retail",
      "poi_address": "7801 Gate Pkwy, Jacksonville, FL 32256, USA",
      "poi_short_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_long_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f1509-fabc-76b7-9338-5a271b4928c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-fabc-76b7-9338-5a271b4928c0",
        "storage_key": "property/5134493690101760/019f1509-fabc-76b7-9338-5a271b4928c0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ikea.com/us/en/stores/jacksonville/?utm_source=google&utm_medium=organic&utm_campaign=map&utm_content=jacksonville",
      "poi_directions_map_url": "https://maps.google.com/?cid=1842684368552300310&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ikea",
      "poi_latitude": "30.2373851",
      "poi_longitude": "-81.5165329",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 888-888-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d670-723f-810a-20de45a1008a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d670-723f-810a-20de45a1008a",
        "storage_key": "property/5134493690101760/019f150a-d670-723f-810a-20de45a1008a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVQQCMLPK5YgRFo-5lKuHkhk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "ec_27ce33e939481eb4c9816937",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "The Avenues",
      "poi_type": "Shopping & Retail",
      "poi_address": "10300 Southside Blvd, Jacksonville, FL 32256, USA",
      "poi_short_description": "Bright, modern mall features familiar big-box stores, clothing boutiques, restaurants & a wine bar.",
      "poi_long_description": "Bright, modern mall features familiar big-box stores, clothing boutiques, restaurants & a wine bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-0c13-72fa-9f09-a81024f2521c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150a-0c13-72fa-9f09-a81024f2521c",
        "storage_key": "property/5134493690101760/019f150a-0c13-72fa-9f09-a81024f2521c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/the-avenues",
      "poi_directions_map_url": "https://maps.google.com/?cid=10488048585255883970&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-avenues",
      "poi_latitude": "30.184439",
      "poi_longitude": "-81.554024",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 37 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 904-363-3060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d670-723f-810a-20de45a1008a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d670-723f-810a-20de45a1008a",
        "storage_key": "property/5134493690101760/019f150a-d670-723f-810a-20de45a1008a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjQlbVnPL5YgRwhQ3x54IjZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_fd8907a14e55fa9033827775",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Total Wine & More",
      "poi_type": "Shopping & Retail",
      "poi_address": "4413 Town Center Pkwy Ste 300, Jacksonville, FL 32246, USA",
      "poi_short_description": "Family-owned chain retailer offering a wide selection of wine, beer & spirits.",
      "poi_long_description": "Family-owned chain retailer offering a wide selection of wine, beer & spirits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-6263-7795-8c86-296312d5eb4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-6263-7795-8c86-296312d5eb4d",
        "storage_key": "property/5134493690101760/019f150c-6263-7795-8c86-296312d5eb4d.webp",
        "width": 570,
        "height": 317
      },
      "poi_business_url": "https://www.totalwine.com/store-info/florida-jacksonville/907?cid=referral:website_link::momentfeed:907_jacksonville_store_details_page:",
      "poi_directions_map_url": "https://maps.google.com/?cid=18094799531358180342&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "total-wine--more",
      "poi_latitude": "30.2628032",
      "poi_longitude": "-81.526887",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 904-998-1740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d670-723f-810a-20de45a1008a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d670-723f-810a-20de45a1008a",
        "storage_key": "property/5134493690101760/019f150a-d670-723f-810a-20de45a1008a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJLZsOUUW15YgR9lOCrE2kHfs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "liquor_store"
    },
    {
      "id": "ec_ced367062bbb4ab5d729692a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Kernan Trail Elementary School",
      "poi_type": "Education",
      "poi_address": "2281 Kernan Blvd S, Jacksonville, FL 32246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-632e-729e-b505-4dfe28512f84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-632e-729e-b505-4dfe28512f84",
        "storage_key": "property/5134493690101760/019f150c-632e-729e-b505-4dfe28512f84.webp",
        "width": 1280,
        "height": 898
      },
      "poi_business_url": "https://www.duvalschools.org/kernantrail",
      "poi_directions_map_url": "https://maps.google.com/?cid=5966742585805350427&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kernan-trail-elementary-school",
      "poi_latitude": "30.30472159999999",
      "poi_longitude": "-81.4818014",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 904-220-1310",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a5-75ec-adde-378b177bc8aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a5-75ec-adde-378b177bc8aa",
        "storage_key": "property/5134493690101760/019f150a-d6a5-75ec-adde-378b177bc8aa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmRcF8eFK5IgRG6YfxcQgzlI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_e0ef821763ebdf4d82e3c8c5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Sandalwood High School",
      "poi_type": "Education",
      "poi_address": "2750 John Prom Blvd, Jacksonville, FL 32246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-64c0-7557-82b0-2e9f00435bdb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-64c0-7557-82b0-2e9f00435bdb",
        "storage_key": "property/5134493690101760/019f150c-64c0-7557-82b0-2e9f00435bdb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.duvalschools.org/sandalwood",
      "poi_directions_map_url": "https://maps.google.com/?cid=6900108786322991883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sandalwood-high-school",
      "poi_latitude": "30.2970504",
      "poi_longitude": "-81.5178626",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-646-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a5-75ec-adde-378b177bc8aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a5-75ec-adde-378b177bc8aa",
        "storage_key": "property/5134493690101760/019f150a-d6a5-75ec-adde-378b177bc8aa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJo6jfkiq15YgRC2tVAGIcwl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_a2282c77be17ad39f122b157",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Twin Lakes Academy Middle School",
      "poi_type": "Education",
      "poi_address": "8050 Point Meadows Dr, Jacksonville, FL 32256, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-62de-751f-95d6-b13f8591c377.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-62de-751f-95d6-b13f8591c377",
        "storage_key": "property/5134493690101760/019f150c-62de-751f-95d6-b13f8591c377.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.duvalschools.org/tlam",
      "poi_directions_map_url": "https://maps.google.com/?cid=18134562247312556594&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "twin-lakes-academy-middle-school",
      "poi_latitude": "30.2220985",
      "poi_longitude": "-81.5158392",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 904-538-0825",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a5-75ec-adde-378b177bc8aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a5-75ec-adde-378b177bc8aa",
        "storage_key": "property/5134493690101760/019f150a-d6a5-75ec-adde-378b177bc8aa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcdpFRDM15IgRMkJGbEjoqvs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_a852c0b9d33d4a77f93ef6e1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Hogan-Spring Glen Elementary School",
      "poi_type": "Education",
      "poi_address": "6736 Beach Blvd, Jacksonville, FL 32216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.duvalschools.org/hsg",
      "poi_directions_map_url": "https://maps.google.com/?cid=3449445742288297391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hogan-spring-glen-elementary-school",
      "poi_latitude": "30.2890067",
      "poi_longitude": "-81.5895874",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-720-1640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a5-75ec-adde-378b177bc8aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a5-75ec-adde-378b177bc8aa",
        "storage_key": "property/5134493690101760/019f150a-d6a5-75ec-adde-378b177bc8aa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWxax88S15YgRr90TbaDk3i8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_1c34669b511f3da9403249ab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Duval Charter School at Southside K-8",
      "poi_type": "Education",
      "poi_address": "8680 A C Skinner Pkwy, Jacksonville, FL 32256, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-6320-7281-a983-44168196d2ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-6320-7281-a983-44168196d2ec",
        "storage_key": "property/5134493690101760/019f150c-6320-7281-a983-44168196d2ec.webp",
        "width": 1280,
        "height": 457
      },
      "poi_business_url": "https://www.southsidecharter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2864933085218957656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "duval-charter-school-at-southside-k-8",
      "poi_latitude": "30.2466057",
      "poi_longitude": "-81.55465439999999",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 904-423-5348",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a5-75ec-adde-378b177bc8aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a5-75ec-adde-378b177bc8aa",
        "storage_key": "property/5134493690101760/019f150a-d6a5-75ec-adde-378b177bc8aa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCWShcIbK5YgRWGm9QXZJwic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_a5e7d2e11ba59a091389fde2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "KidsPark - JAX",
      "poi_type": "Education",
      "poi_address": "9726 Touchton Rd Ste 111, Jacksonville, FL 32246, USA",
      "poi_short_description": "Kid -friendly center featuring hourly pay-as-you-play care, plus activities and crafts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-6592-75e1-9019-31f877919f66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-6592-75e1-9019-31f877919f66",
        "storage_key": "property/5134493690101760/019f150c-6592-75e1-9019-31f877919f66.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kidspark.com/find-your-center/our-locations/florida/touchton-center-fl/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6801945027591177828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kidspark---jax",
      "poi_latitude": "30.2674304",
      "poi_longitude": "-81.5552622",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 904-683-4554",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a5-75ec-adde-378b177bc8aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a5-75ec-adde-378b177bc8aa",
        "storage_key": "property/5134493690101760/019f150a-d6a5-75ec-adde-378b177bc8aa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1yyoXHe15YgRZIZO3_ZcZV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_193e6e6814773ad293696a87",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Rattles to Tassels Learning Center",
      "poi_type": "Education",
      "poi_address": "9701 Anders Blvd, Jacksonville, FL 32246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-66a1-7124-9d5b-dda185747233.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-66a1-7124-9d5b-dda185747233",
        "storage_key": "property/5134493690101760/019f150c-66a1-7124-9d5b-dda185747233.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.rattlestotassels.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12024523272312826708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rattles-to-tassels-learning-center",
      "poi_latitude": "30.278269",
      "poi_longitude": "-81.55835300000001",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 904-619-4702",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a5-75ec-adde-378b177bc8aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a5-75ec-adde-378b177bc8aa",
        "storage_key": "property/5134493690101760/019f150a-d6a5-75ec-adde-378b177bc8aa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbx5gSnW15YgRVKufHzWw36Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_6cb8b4d0a357279d54030ef1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "A Bright Beginning Childcare",
      "poi_type": "Education",
      "poi_address": "9762 Deer Lake Ct, Jacksonville, FL 32246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-665d-7505-b8c8-9d4cad2dd12a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-665d-7505-b8c8-9d4cad2dd12a",
        "storage_key": "property/5134493690101760/019f150c-665d-7505-b8c8-9d4cad2dd12a.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://abrightbeginningchildcarejax.com/?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=16507247144888263929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "a-bright-beginning-childcare",
      "poi_latitude": "30.2664606",
      "poi_longitude": "-81.5540347",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 904-606-9242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a5-75ec-adde-378b177bc8aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a5-75ec-adde-378b177bc8aa",
        "storage_key": "property/5134493690101760/019f150a-d6a5-75ec-adde-378b177bc8aa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkwBV-Xm15YgR-WSlstGFFeU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_79e2238f851c4262cd37ed3c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "University of North Florida (UNF)",
      "poi_type": "Education",
      "poi_address": "1 UNF Dr., Jacksonville, FL 32224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-1ac7-7361-99d2-27e4c70d109a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150a-1ac7-7361-99d2-27e4c70d109a",
        "storage_key": "property/5134493690101760/019f150a-1ac7-7361-99d2-27e4c70d109a.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.unf.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18226157899370904914&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-north-florida-unf",
      "poi_latitude": "30.2661204",
      "poi_longitude": "-81.50723140000001",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 904-620-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a5-75ec-adde-378b177bc8aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a5-75ec-adde-378b177bc8aa",
        "storage_key": "property/5134493690101760/019f150a-d6a5-75ec-adde-378b177bc8aa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU2DTHbRK5IgRUr0uDAtS8Pw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_2a56f7af73f0152cd484362a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Jacksonville University",
      "poi_type": "Education",
      "poi_address": "2800 University Blvd N, Jacksonville, FL 32211, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-6832-778a-b826-042d69c52051.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-6832-778a-b826-042d69c52051",
        "storage_key": "property/5134493690101760/019f150c-6832-778a-b826-042d69c52051.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "https://www.ju.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4823538255824375235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jacksonville-university",
      "poi_latitude": "30.3529114",
      "poi_longitude": "-81.606213",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 904-256-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a5-75ec-adde-378b177bc8aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a5-75ec-adde-378b177bc8aa",
        "storage_key": "property/5134493690101760/019f150a-d6a5-75ec-adde-378b177bc8aa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZzEzWVSx5YgRw03rynym8EI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_3643df4a6701e1a11dea827f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Cinemark Tinseltown Jacksonville and XD",
      "poi_type": "Entertainment",
      "poi_address": "4535 Southside Blvd, Jacksonville, FL 32216, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-6b5a-76ad-89f7-a453f64660f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-6b5a-76ad-89f7-a453f64660f0",
        "storage_key": "property/5134493690101760/019f150c-6b5a-76ad-89f7-a453f64660f0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/fl-jacksonville/cinemark-tinseltown-jacksonville-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMxNDctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=8362422929890279661&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-tinseltown-jacksonville-and-xd",
      "poi_latitude": "30.2633455",
      "poi_longitude": "-81.553895",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 904-998-2122",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-a26e-765c-9869-934aa5e24e3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-a26e-765c-9869-934aa5e24e3d",
        "storage_key": "property/5134493690101760/019f150c-a26e-765c-9869-934aa5e24e3d.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2WxdxH615YgR7QCxRVlLDXQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_e411adcbeee4f66312ee4f15",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "St. Johns Town Center",
      "poi_type": "Entertainment",
      "poi_address": "4663 River City Dr, Jacksonville, FL 32246, USA",
      "poi_short_description": "Outdoor mall with known fashion, home goods & electronics brands, sit-down dining & quick snacks.",
      "poi_long_description": "Outdoor mall with known fashion, home goods & electronics brands, sit-down dining & quick snacks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f1509-fb32-777d-b9b3-562408f97fe2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-fb32-777d-b9b3-562408f97fe2",
        "storage_key": "property/5134493690101760/019f1509-fb32-777d-b9b3-562408f97fe2.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.simon.com/mall/st-johns-town-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=18063775443598808474&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-johns-town-center",
      "poi_latitude": "30.2568706",
      "poi_longitude": "-81.5253244",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 904-998-7156",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d670-723f-810a-20de45a1008a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d670-723f-810a-20de45a1008a",
        "storage_key": "property/5134493690101760/019f150a-d670-723f-810a-20de45a1008a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJFX_HOVe15YgRmpUhWg9sr_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_fb16f8813043955eb04987e1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Topgolf Jacksonville",
      "poi_type": "Entertainment",
      "poi_address": "10531 Brightman Blvd, Jacksonville, FL 32246, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f1509-f464-76ec-af82-7053805488a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-f464-76ec-af82-7053805488a8",
        "storage_key": "property/5134493690101760/019f1509-f464-76ec-af82-7053805488a8.webp",
        "width": 1000,
        "height": 720
      },
      "poi_business_url": "https://topgolf.com/us/jacksonville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=551425716930125462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-jacksonville",
      "poi_latitude": "30.2632674",
      "poi_longitude": "-81.5205175",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-328-2002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a6-7329-be2b-bdf879e53035",
        "storage_key": "property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPUWBGFK15YgRlp6imcQOpwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_5a17c6789ef946605b2671f1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Main Event Jacksonville",
      "poi_type": "Entertainment",
      "poi_address": "10370 Philips Hwy, Jacksonville, FL 32256, USA",
      "poi_short_description": "Games and a bar featuring American eats like wings and burgers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-6b14-715b-b17b-cbd3e09c5037.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-6b14-715b-b17b-cbd3e09c5037",
        "storage_key": "property/5134493690101760/019f150c-6b14-715b-b17b-cbd3e09c5037.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.mainevent.com/locations/florida/jacksonville",
      "poi_directions_map_url": "https://maps.google.com/?cid=16907461409632428594&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-event-jacksonville",
      "poi_latitude": "30.1802857",
      "poi_longitude": "-81.55505629999999",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 904-260-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a6-7329-be2b-bdf879e53035",
        "storage_key": "property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB5PzpHbL5YgRMiLEjpJeo-o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_9b4d1fb73ad09067ad0d7fbd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "K1 Speed Jacksonville",
      "poi_type": "Entertainment",
      "poi_address": "6601 Executive Park Ct N, Jacksonville, FL 32216, USA",
      "poi_short_description": "Indoor go-kart racing center offering 2 tracks & modern, Italian-made karts, plus parties & leagues.",
      "poi_long_description": "Indoor go-kart racing center offering 2 tracks & modern, Italian-made karts, plus parties & leagues.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-6bac-702b-ab63-0dc949be7075.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-6bac-702b-ab63-0dc949be7075",
        "storage_key": "property/5134493690101760/019f150c-6bac-702b-ab63-0dc949be7075.webp",
        "width": 1280,
        "height": 769
      },
      "poi_business_url": "https://www.k1speed.com/jacksonville-location.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=12080430048114212549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "k1-speed-jacksonville",
      "poi_latitude": "30.2551278",
      "poi_longitude": "-81.6023373",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 904-425-5005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66c-76fc-8edd-939ac8d3841e",
        "storage_key": "property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2eb1zAHK5YgRxX7Ntx9Ppqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_42a3af7b6c3d9d6b4d07777d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Deerwood Castle",
      "poi_type": "Entertainment",
      "poi_address": "7601 Centurion Pkwy N, Jacksonville, FL 32256, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-6bb1-7192-8858-42cf1c787da4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-6bb1-7192-8858-42cf1c787da4",
        "storage_key": "property/5134493690101760/019f150c-6bb1-7192-8858-42cf1c787da4.webp",
        "width": 1080,
        "height": 720
      },
      "poi_business_url": "http://www.deerwoodcastle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3984180645542801190&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deerwood-castle",
      "poi_latitude": "30.2398132",
      "poi_longitude": "-81.54328699999999",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 904-478-5530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66c-76fc-8edd-939ac8d3841e",
        "storage_key": "property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkyUvBrvL5YgRJq-QIjCnSjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_2c78c5e3e4ef22e63b8e7821",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Jacksonville Zoo and Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "370 Zoo Pkwy, Jacksonville, FL 32218, USA",
      "poi_short_description": "Vast zoo highlighting local as well as African wildlife with gardens, a train & a kids' zone.",
      "poi_long_description": "Vast zoo highlighting local as well as African wildlife with gardens, a train & a kids' zone.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-6bbf-72b9-9f1e-c52fd1619f34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-6bbf-72b9-9f1e-c52fd1619f34",
        "storage_key": "property/5134493690101760/019f150c-6bbf-72b9-9f1e-c52fd1619f34.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.jacksonvillezoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14793728661843698434&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jacksonville-zoo-and-botanical-gardens",
      "poi_latitude": "30.4040262",
      "poi_longitude": "-81.6436476",
      "poi_miles_from_property": "15.5 mi",
      "poi_walking_minutes": "5 hours 48 mins",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 904-757-4463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66c-76fc-8edd-939ac8d3841e",
        "storage_key": "property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5UOOwKux5YgRAmO1YNbhTc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "ec_81f053d8ba937c515d6cba3c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Cummer Museum of Art & Gardens",
      "poi_type": "Entertainment",
      "poi_address": "829 Riverside Ave, Jacksonville, FL 32204, USA",
      "poi_short_description": "Museum showcases 5,000 works of art from all eras in a riverfront site surrounded by gardens.",
      "poi_long_description": "Museum showcases 5,000 works of art from all eras in a riverfront site surrounded by gardens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-6eeb-7075-b13b-80860122bb7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-6eeb-7075-b13b-80860122bb7a",
        "storage_key": "property/5134493690101760/019f150c-6eeb-7075-b13b-80860122bb7a.webp",
        "width": 640,
        "height": 426
      },
      "poi_business_url": "http://www.cummermuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1730978020932146253&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cummer-museum-of-art--gardens",
      "poi_latitude": "30.3150334",
      "poi_longitude": "-81.6766992",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 904-356-6857",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d669-7018-835c-e4d7f1c6e41a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d669-7018-835c-e4d7f1c6e41a",
        "storage_key": "property/5134493690101760/019f150a-d669-7018-835c-e4d7f1c6e41a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJrbZAOHG35YgRTVSrw1arBRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_963a59ce6f2a67292dfe7810",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "MOSH (Museum Of Science & History)",
      "poi_type": "Entertainment",
      "poi_address": "1025 Museum Cir, Jacksonville, FL 32207, USA",
      "poi_short_description": "Aquariums & exhibits on the body, marine mammals & energy are featured at this popular museum.",
      "poi_long_description": "Aquariums & exhibits on the body, marine mammals & energy are featured at this popular museum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-714c-70fa-bd6b-d03fb10fbd3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-714c-70fa-bd6b-d03fb10fbd3c",
        "storage_key": "property/5134493690101760/019f150c-714c-70fa-bd6b-d03fb10fbd3c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://themosh.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7369837136756052471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mosh-museum-of-science--history",
      "poi_latitude": "30.31886519999999",
      "poi_longitude": "-81.65976669999999",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 904-396-6674",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d669-7018-835c-e4d7f1c6e41a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d669-7018-835c-e4d7f1c6e41a",
        "storage_key": "property/5134493690101760/019f150a-d669-7018-835c-e4d7f1c6e41a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJn1gEIRC35YgR95HTLNTrRmY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_8b9101ecd3c54a7836ad36b8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Jacksonville Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "300 Water St, Jacksonville, FL 32202, USA",
      "poi_short_description": "Dance, theater, the symphony & more presented in a modern complex housing 3 theaters of varied size.",
      "poi_long_description": "Dance, theater, the symphony & more presented in a modern complex housing 3 theaters of varied size.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-71a3-7715-a20c-598d0508ddb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-71a3-7715-a20c-598d0508ddb5",
        "storage_key": "property/5134493690101760/019f150c-71a3-7715-a20c-598d0508ddb5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.jacksonvillecenterfortheperformingarts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14290164464635519022&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jacksonville-center-for-the-performing-arts",
      "poi_latitude": "30.324873",
      "poi_longitude": "-81.66274949999999",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 904-633-6110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66c-76fc-8edd-939ac8d3841e",
        "storage_key": "property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_Sh7ShG35YgRLqCCON7cUMY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_00a2e198ca613e9cc9ab5c7b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Ascension St. Vincent's Southside Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4201 Belfort Rd, Jacksonville, FL 32216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-6f35-724c-97be-3348191de176.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-6f35-724c-97be-3348191de176",
        "storage_key": "property/5134493690101760/019f150c-6f35-724c-97be-3348191de176.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/florida/fljac/jacksonville-ascension-st-vincents-southside?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=14571536335466991100&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ascension-st-vincents-southside-hospital",
      "poi_latitude": "30.2537768",
      "poi_longitude": "-81.5818216",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 904-296-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66d-7581-ad77-0453705a1673.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66d-7581-ad77-0453705a1673",
        "storage_key": "property/5134493690101760/019f150a-d66d-7581-ad77-0453705a1673.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVVVXm35YgR_A01Axh_OMo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_d4c14643d2c9ec6aa3532158",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Baptist & Wolfson Town Center Emergency Room (ER)",
      "poi_type": "Health and Wellness",
      "poi_address": "4085 Town Center Pkwy, Jacksonville, FL 32246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-7083-7665-8785-d6b8f4014332.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-7083-7665-8785-d6b8f4014332",
        "storage_key": "property/5134493690101760/019f150c-7083-7665-8785-d6b8f4014332.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.baptistjax.com/immediate-care/er/baptist-town-center-er",
      "poi_directions_map_url": "https://maps.google.com/?cid=18194539370640456871&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baptist--wolfson-town-center-emergency-room-er",
      "poi_latitude": "30.2664667",
      "poi_longitude": "-81.522801",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-202-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66c-76fc-8edd-939ac8d3841e",
        "storage_key": "property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJofw8q0-15YgRpzzipij9f_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_d4a0b63bab36582fb450c399",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Baptist Medical Center South",
      "poi_type": "Health and Wellness",
      "poi_address": "14550 Old St Augustine Rd, Jacksonville, FL 32258, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-714b-7512-8d14-dbddd0da3033.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-714b-7512-8d14-dbddd0da3033",
        "storage_key": "property/5134493690101760/019f150c-714b-7512-8d14-dbddd0da3033.webp",
        "width": 961,
        "height": 540
      },
      "poi_business_url": "https://www.baptistjax.com/locations/baptist-medical-center-south",
      "poi_directions_map_url": "https://maps.google.com/?cid=17032379235963437627&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baptist-medical-center-south",
      "poi_latitude": "30.1375744",
      "poi_longitude": "-81.53533759999999",
      "poi_miles_from_property": "17.2 mi",
      "poi_walking_minutes": "6 hours 21 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 904-271-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66d-7581-ad77-0453705a1673.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66d-7581-ad77-0453705a1673",
        "storage_key": "property/5134493690101760/019f150a-d66d-7581-ad77-0453705a1673.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ___TUPos5IgROwJXd6wqX-w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_d13fb3906de1d8d2edd835d3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "UF Health Emergency & Urgent Care Center - Baymeadows",
      "poi_type": "Health and Wellness",
      "poi_address": "11251 Lamb Tail Ln, Jacksonville, FL 32256, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-7638-771e-9983-646d45bcff31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-7638-771e-9983-646d45bcff31",
        "storage_key": "property/5134493690101760/019f150c-7638-771e-9983-646d45bcff31.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://euc.ufhealthjax.org/locations/uf-health-emergency-urgent-care-center-baymeadow/?utm_source=loclistings&utm_medium=organic&y_source=1_MTA1MTk2OTM0NS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5792403899402929642&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uf-health-emergency--urgent-care-center---baymeadows",
      "poi_latitude": "30.2153667",
      "poi_longitude": "-81.5119922",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 904-427-7254",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66c-76fc-8edd-939ac8d3841e",
        "storage_key": "property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX7IJXoI15IgR6sV_M6jAYlA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_a5c97649e71860b40dd8be25",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4893 Town Center Pkwy, Jacksonville, FL 32246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-739d-7799-9293-30093bf8e7a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-739d-7799-9293-30093bf8e7a8",
        "storage_key": "property/5134493690101760/019f150c-739d-7799-9293-30093bf8e7a8.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/jacksonville-fl-pharmacies/4893-town-center-parkway-jacksonville-fl-32246/storeid=8902?WT.mc_id=LS_GOOGLE_RX_8902",
      "poi_directions_map_url": "https://maps.google.com/?cid=17659291093801375781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "30.2541482",
      "poi_longitude": "-81.5353868",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 904-642-2442",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-a2cc-74c9-9ae2-e50f347c421e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-a2cc-74c9-9ae2-e50f347c421e",
        "storage_key": "property/5134493690101760/019f150c-a2cc-74c9-9ae2-e50f347c421e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO3aSh1-15YgRJRhA169nEvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_be8aac512464de83f6d7845a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Publix Pharmacy at St. John's Town Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4413 Town Center Pkwy #100, Jacksonville, FL 32246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-75f2-7019-b6fa-c08e8366bfa1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-75f2-7019-b6fa-c08e8366bfa1",
        "storage_key": "property/5134493690101760/019f150c-75f2-7019-b6fa-c08e8366bfa1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/pharmacy?utm_medium=maps&utm_source=google&utm_content=psmpharm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=2678093263034308210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-pharmacy-at-st-johns-town-center",
      "poi_latitude": "30.2642229",
      "poi_longitude": "-81.5263916",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 904-564-3790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-a2cc-74c9-9ae2-e50f347c421e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-a2cc-74c9-9ae2-e50f347c421e",
        "storage_key": "property/5134493690101760/019f150c-a2cc-74c9-9ae2-e50f347c421e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLZsOUUW15YgRctaGMqJ_KiU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_23518d644bcf5f5e68cb9980",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9734 Deer Lake Ct Ste 6-7, Jacksonville, FL 32246, USA",
      "poi_short_description": "Gym specializing in group workouts that combine cardio and strength training to hit the optimal fitness zone.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-8075-7497-a84c-4c78823129a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-8075-7497-a84c-4c78823129a4",
        "storage_key": "property/5134493690101760/019f150c-8075-7497-a84c-4c78823129a4.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/jacksonville-florida-0836?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=14841905586547511692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "30.2648984",
      "poi_longitude": "-81.55478459999999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 904-559-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66c-76fc-8edd-939ac8d3841e",
        "storage_key": "property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnQ9L9Hm15YgRjNEMxH4K-c0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_821cd42c1872c7f7346b1686",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Pure Barre",
      "poi_type": "Health and Wellness",
      "poi_address": "4828 W Deer Lake Dr Suite 7, Jacksonville, FL 32246, USA",
      "poi_short_description": "Chain fitness studio offering low-impact, high-intensity group classes inspired by ballet, Pilates, and yoga.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-752f-7628-adf7-caf299f30a68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-752f-7628-adf7-caf299f30a68",
        "storage_key": "property/5134493690101760/019f150c-752f-7628-adf7-caf299f30a68.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.purebarre.com/location/jacksonville-tapestry-park-fl",
      "poi_directions_map_url": "https://maps.google.com/?cid=14363205406355121501&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pure-barre",
      "poi_latitude": "30.2589409",
      "poi_longitude": "-81.5542785",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 904-564-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66c-76fc-8edd-939ac8d3841e",
        "storage_key": "property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXcFUmX615YgRXWXEsTdbVMc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_8a64677ac9788c43e85e52c1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Moksha Yoga + Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "9726 Touchton Rd #110, Jacksonville, FL 32246, USA",
      "poi_short_description": "Studio offering various yoga classes, plus spa services such as massage therapy and infrared sauna.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-7971-7419-9410-7e014825ee90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-7971-7419-9410-7e014825ee90",
        "storage_key": "property/5134493690101760/019f150c-7971-7419-9410-7e014825ee90.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.mokshayogaspa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1503602573901512048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moksha-yoga--spa",
      "poi_latitude": "30.2676167",
      "poi_longitude": "-81.5551844",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 904-888-6880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a5-75ec-adde-378b177bc8aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a5-75ec-adde-378b177bc8aa",
        "storage_key": "property/5134493690101760/019f150a-d6a5-75ec-adde-378b177bc8aa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiwFmJIS15YgRcD3DFJPe3RQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_ba4dd14c5d99591a482ccae8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Crunch Fitness - Regency Park",
      "poi_type": "Health and Wellness",
      "poi_address": "9400 Atlantic Blvd, Jacksonville, FL 32225, USA",
      "poi_short_description": "Chain gym at Regency Park Shopping Center offering cardio and strength-training equipment, plus group classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-347f-744f-be5f-e3c1ae610460.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150a-347f-744f-be5f-e3c1ae610460",
        "storage_key": "property/5134493690101760/019f150a-347f-744f-be5f-e3c1ae610460.webp",
        "width": 900,
        "height": 600
      },
      "poi_business_url": "http://crunch.com/locations/regency-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9765840362978010024&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crunch-fitness---regency-park",
      "poi_latitude": "30.31830669999999",
      "poi_longitude": "-81.55227239999999",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 904-456-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66c-76fc-8edd-939ac8d3841e",
        "storage_key": "property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0adOT1C15YgRqON5iBE8h4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_4d5b9ccbba92e7c45e849c29",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Deerwood Rotary Childrens Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7901 Baymeadows Rd E, Jacksonville, FL 32256, USA",
      "poi_short_description": "Well-kept park featuring 2 playgrounds, a water fountain, swings and slides for kids of all ages.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-796b-74a6-b69f-e4dcaaed1a3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-796b-74a6-b69f-e4dcaaed1a3f",
        "storage_key": "property/5134493690101760/019f150c-796b-74a6-b69f-e4dcaaed1a3f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.coj.net/departments/parks-and-recreation/recreation-and-community-programming/parks/deerwood-rotary-childrens-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9959795523271334661&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deerwood-rotary-childrens-park",
      "poi_latitude": "30.2288538",
      "poi_longitude": "-81.5090835",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 904-255-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6b5-7382-ab81-520319c38b07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6b5-7382-ab81-520319c38b07",
        "storage_key": "property/5134493690101760/019f150a-d6b5-7382-ab81-520319c38b07.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8dImGjY15IgRBRsdWEJNOIo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c3854f01b343c74e25c1d2f5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Touchton Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8551 Touchton Rd, Jacksonville, FL 32246, USA",
      "poi_short_description": "Modern play area, plus a pond, exercise equipment and picnic tables.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-784d-73fe-b458-452b79a2fd62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-784d-73fe-b458-452b79a2fd62",
        "storage_key": "property/5134493690101760/019f150c-784d-73fe-b458-452b79a2fd62.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jacksonville.gov/departments/parks-and-recreation/recreation-and-community-programming/parks/touchton-road-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15168449709089788301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "touchton-park",
      "poi_latitude": "30.2697071",
      "poi_longitude": "-81.5689036",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6b5-7382-ab81-520319c38b07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6b5-7382-ab81-520319c38b07",
        "storage_key": "property/5134493690101760/019f150a-d6b5-7382-ab81-520319c38b07.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8YXDMnW15YgRjZGs_6QogdI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c02212c385b67276e410f9b1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "The Beach and Peach Urban Bike Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10013 Anders Blvd, Jacksonville, FL 32246, USA",
      "poi_short_description": "Small, low-key swath of green space with unpaved biking & hiking trails & a fishing pond.",
      "poi_long_description": "Small, low-key swath of green space with unpaved biking & hiking trails & a fishing pond.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-8062-740b-8052-a8c99efd20e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-8062-740b-8052-a8c99efd20e0",
        "storage_key": "property/5134493690101760/019f150c-8062-740b-8052-a8c99efd20e0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.coj.net/departments/parks-and-recreation/recreation-and-community-programming/parks/beach-and-peach-urban-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=18086790759414514098&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-beach-and-peach-urban-bike-park",
      "poi_latitude": "30.278133",
      "poi_longitude": "-81.552433",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 904-233-7450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6b5-7382-ab81-520319c38b07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6b5-7382-ab81-520319c38b07",
        "storage_key": "property/5134493690101760/019f150a-d6b5-7382-ab81-520319c38b07.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJoQcLlg615YgRskG4JV4wAfs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_b441633a28ae78afd6746cab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Southside Estates Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9775 Ivey Rd, Jacksonville, FL 32246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-8019-75f9-9985-3e59f27b259a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-8019-75f9-9985-3e59f27b259a",
        "storage_key": "property/5134493690101760/019f150c-8019-75f9-9985-3e59f27b259a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dcps.duvalschools.org/ssee",
      "poi_directions_map_url": "https://maps.google.com/?cid=8046582145867542944&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southside-estates-park",
      "poi_latitude": "30.2981973",
      "poi_longitude": "-81.55390609999999",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 904-565-2706",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6b5-7382-ab81-520319c38b07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6b5-7382-ab81-520319c38b07",
        "storage_key": "property/5134493690101760/019f150a-d6b5-7382-ab81-520319c38b07.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBWXttQO15YgRoHFvPNQzq28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_1a89b3349b74bf51752d6cea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "St. Johns Town Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4663 River City Dr, Jacksonville, FL 32246, USA",
      "poi_short_description": "Outdoor mall with known fashion, home goods & electronics brands, sit-down dining & quick snacks.",
      "poi_long_description": "Outdoor mall with known fashion, home goods & electronics brands, sit-down dining & quick snacks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f1509-fb32-777d-b9b3-562408f97fe2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-fb32-777d-b9b3-562408f97fe2",
        "storage_key": "property/5134493690101760/019f1509-fb32-777d-b9b3-562408f97fe2.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.simon.com/mall/st-johns-town-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=18063775443598808474&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-johns-town-center",
      "poi_latitude": "30.2568706",
      "poi_longitude": "-81.5253244",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 904-998-7156",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d670-723f-810a-20de45a1008a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d670-723f-810a-20de45a1008a",
        "storage_key": "property/5134493690101760/019f150a-d670-723f-810a-20de45a1008a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJFX_HOVe15YgRmpUhWg9sr_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_489635b374e393dc131a02ac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Lovelace Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6401 Barnes Rd S, Jacksonville, FL 32216, USA",
      "poi_short_description": "Secluded park with trails, playgrounds, picnic tables, slides, gazebos and BBQ grills.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-8133-704b-a5b9-79ceed12d2f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-8133-704b-a5b9-79ceed12d2f3",
        "storage_key": "property/5134493690101760/019f150c-8133-704b-a5b9-79ceed12d2f3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.coj.net/departments/parks-and-recreation/recreation-and-community-programming/parks/lovelace-park.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=933172389785554869&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lovelace-park",
      "poi_latitude": "30.2710456",
      "poi_longitude": "-81.59904709999999",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 904-255-7907",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6b5-7382-ab81-520319c38b07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6b5-7382-ab81-520319c38b07",
        "storage_key": "property/5134493690101760/019f150a-d6b5-7382-ab81-520319c38b07.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ72Bp_eK15YgRtc9eJ1hL8ww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_082fd0d382e5ce4f59032623",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Adolph Wurn Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2115 Dean Rd, Jacksonville, FL 32216, USA",
      "poi_short_description": "Park with a lake, a playground, basketball courts, and a baseball field.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-80ce-7279-8067-314d95c5562f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-80ce-7279-8067-314d95c5562f",
        "storage_key": "property/5134493690101760/019f150c-80ce-7279-8067-314d95c5562f.webp",
        "width": 1280,
        "height": 919
      },
      "poi_business_url": "http://www.coj.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16853344973311308286&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adolph-wurn-park",
      "poi_latitude": "30.2838259",
      "poi_longitude": "-81.59099839999999",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 904-255-7919",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6b5-7382-ab81-520319c38b07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6b5-7382-ab81-520319c38b07",
        "storage_key": "property/5134493690101760/019f150a-d6b5-7382-ab81-520319c38b07.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8x00H8O15YgR_vFV2_Ub4-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_ca75039909538ccb18148e37",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Hotel Indigo Jacksonville-Deerwood Park by IHG",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9840 Tapestry Park Circle, Jacksonville, FL 32246, USA",
      "poi_short_description": "Colorful, modern rooms with wall murals, plus an outdoor pool & a bistro with a lakeside patio.",
      "poi_long_description": "Colorful, modern rooms with wall murals, plus an outdoor pool & a bistro with a lakeside patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-85a6-706f-a608-68eb93213114.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-85a6-706f-a608-68eb93213114",
        "storage_key": "property/5134493690101760/019f150c-85a6-706f-a608-68eb93213114.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.ihg.com/hotelindigo/hotels/us/en/jacksonville/jaxin/hoteldetail?cm_mmc=GoogleMaps-_-IN-_-US-_-JAXIN",
      "poi_directions_map_url": "https://maps.google.com/?cid=2923006964927743619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotel-indigo-jacksonville-deerwood-park-by-ihg",
      "poi_latitude": "30.2581064",
      "poi_longitude": "-81.5522112",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 904-996-7199",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-a336-7218-bf39-9a43908b7ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-a336-7218-bf39-9a43908b7ef1",
        "storage_key": "property/5134493690101760/019f150c-a336-7218-bf39-9a43908b7ef1.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJG3tXTXy15YgRg8aCDFmbkCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "ec_4cebb88a3337caa8c24ead4c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Gate Pkwy. & Touchton Rd.",
      "poi_type": "Transportation & Transit",
      "poi_address": "Jacksonville, FL 32246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1447579848986304884&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gate-pkwy--touchton-rd",
      "poi_latitude": "30.261314",
      "poi_longitude": "-81.548628",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66c-76fc-8edd-939ac8d3841e",
        "storage_key": "property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLaI0rWS15YgRdKHX-jPWFhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_4a3604a940b5f364d4417955",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Prati Italia",
      "poi_type": "Transportation & Transit",
      "poi_address": "4972 Big Island Drive, Jacksonville, FL 32246, USA",
      "poi_short_description": "Industrial-chic scene with a glam vibe plating carefully-sourced Italian fare & stylish drinks.",
      "poi_long_description": "Industrial-chic scene with a glam vibe plating carefully-sourced Italian fare & stylish drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-86b4-760e-8567-5b55d50358cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-86b4-760e-8567-5b55d50358cd",
        "storage_key": "property/5134493690101760/019f150c-86b4-760e-8567-5b55d50358cd.webp",
        "width": 1067,
        "height": 1280
      },
      "poi_business_url": "http://www.pratiitalia.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17777289750978936987&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prati-italia",
      "poi_latitude": "30.2515553",
      "poi_longitude": "-81.5283434",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 904-998-9744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a6-7329-be2b-bdf879e53035",
        "storage_key": "property/5134493690101760/019f150a-d6a6-7329-be2b-bdf879e53035.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJSMiFpHL5YgRm8BKJNeetfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_32febf5e699dfd7c19512099",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "10151 Gate Pkwy.",
      "poi_type": "Transportation & Transit",
      "poi_address": "Jacksonville, FL 32246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-8c8d-772c-a45f-ab4f49778a76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-8c8d-772c-a45f-ab4f49778a76",
        "storage_key": "property/5134493690101760/019f150c-8c8d-772c-a45f-ab4f49778a76.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17001411157656168939&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "10151-gate-pkwy",
      "poi_latitude": "30.2563809",
      "poi_longitude": "-81.53768560000002",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66c-76fc-8edd-939ac8d3841e",
        "storage_key": "property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJxR021-15YgR62l13F4l8es",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_a084e839ab1d6a608303cc30",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "JRTC - Jacksonville Regional Transportation Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "100 LaVilla Center Drive, Jacksonville, FL 32204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-890d-711a-aea5-3d7476ef5d53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-890d-711a-aea5-3d7476ef5d53",
        "storage_key": "property/5134493690101760/019f150c-890d-711a-aea5-3d7476ef5d53.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14905535492629981391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jrtc---jacksonville-regional-transportation-center",
      "poi_latitude": "30.3290687",
      "poi_longitude": "-81.6724579",
      "poi_miles_from_property": "10.1 mi",
      "poi_walking_minutes": "3 hours 47 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66c-76fc-8edd-939ac8d3841e",
        "storage_key": "property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHS8mSk635YgRz-gvwY4Z284",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_c23ba42e90ec2902d2b3c7cd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Greyhound Intercity Bus Terminal",
      "poi_type": "Transportation & Transit",
      "poi_address": "1111 W Forsyth St, Jacksonville, FL 32204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-8d00-7528-8268-b4ad85bc4a4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-8d00-7528-8268-b4ad85bc4a4f",
        "storage_key": "property/5134493690101760/019f150c-8d00-7528-8268-b4ad85bc4a4f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.greyhound.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10613072214191764054&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-intercity-bus-terminal",
      "poi_latitude": "30.3298286",
      "poi_longitude": "-81.67260879999999",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 48 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 904-356-9976",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66c-76fc-8edd-939ac8d3841e",
        "storage_key": "property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ66AwQmq35YgRVvJ3xvI0SZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_2ec8f20df6d4f59493291ac1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Jacksonville",
      "poi_type": "Transportation & Transit",
      "poi_address": "3570 Clifford Ln, Jacksonville, FL 32209, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-8d5c-703d-8a2f-e04affc22ae8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-8d5c-703d-8a2f-e04affc22ae8",
        "storage_key": "property/5134493690101760/019f150c-8d5c-703d-8a2f-e04affc22ae8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/stations/jax",
      "poi_directions_map_url": "https://maps.google.com/?cid=7671518193627583878&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jacksonville",
      "poi_latitude": "30.3656",
      "poi_longitude": "-81.72389",
      "poi_miles_from_property": "14.5 mi",
      "poi_walking_minutes": "5 hours 26 mins",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66c-76fc-8edd-939ac8d3841e",
        "storage_key": "property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_2UPjyW65YgRhlUe0ya1dmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "ec_adab2a740188537a2313ff55",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Jacksonville International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2400 Yankee Clipper Dr, Jacksonville, FL 32218, USA",
      "poi_short_description": "This airport with on-site lodging also features 2 art galleries with rotating exhibitions.",
      "poi_long_description": "This airport with on-site lodging also features 2 art galleries with rotating exhibitions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-913c-705b-80f8-b68a9c48e401.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-913c-705b-80f8-b68a9c48e401",
        "storage_key": "property/5134493690101760/019f150c-913c-705b-80f8-b68a9c48e401.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.flyjacksonville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1871272610310749030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jacksonville-international-airport",
      "poi_latitude": "30.4943308",
      "poi_longitude": "-81.68714969999999",
      "poi_miles_from_property": "22.8 mi",
      "poi_walking_minutes": "8 hours 27 mins",
      "poi_biking_minutes": "2 hours 21 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 904-741-4902",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6b9-712c-a54c-c6051a21eae3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6b9-712c-a54c-c6051a21eae3",
        "storage_key": "property/5134493690101760/019f150a-d6b9-712c-a54c-c6051a21eae3.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJE0IKb3-v5YgRZnt9T4YY-Bk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_30903609ca2d4ffc927a3fb9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Avenues Walk Park-n-Ride Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "10508 Avenues Walk Blvd, Jacksonville, FL 32258, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-8ce5-702c-90f2-cebbce1e7adc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-8ce5-702c-90f2-cebbce1e7adc",
        "storage_key": "property/5134493690101760/019f150c-8ce5-702c-90f2-cebbce1e7adc.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.jtafla.com/ride-jta/how-to-ride/park-n-ride/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1058484284830957639&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "avenues-walk-park-n-ride-center",
      "poi_latitude": "30.1764331",
      "poi_longitude": "-81.5530462",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "3 hours 53 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 904-630-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66c-76fc-8edd-939ac8d3841e",
        "storage_key": "property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKUBbmzfL5YgRR8CuVdl9sA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_7ec74852991c4767c2c03e65",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "GUIDEWELL",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4800 Deerwood Campus Pkwy Bldg 800/4th Floor, Jacksonville, FL 32246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-8f3d-70bf-a36a-236058b175a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-8f3d-70bf-a36a-236058b175a7",
        "storage_key": "property/5134493690101760/019f150c-8f3d-70bf-a36a-236058b175a7.webp",
        "width": 1280,
        "height": 487
      },
      "poi_business_url": "http://guidewell.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=304540296132868329&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "guidewell",
      "poi_latitude": "30.2529258",
      "poi_longitude": "-81.5462036",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 855-204-4084",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66c-76fc-8edd-939ac8d3841e",
        "storage_key": "property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXW1whZ3K5YgR6bjKKsnxOQQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_0f08a932115207efb3300e79",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "University of North Florida (UNF)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 UNF Dr., Jacksonville, FL 32224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-1ac7-7361-99d2-27e4c70d109a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150a-1ac7-7361-99d2-27e4c70d109a",
        "storage_key": "property/5134493690101760/019f150a-1ac7-7361-99d2-27e4c70d109a.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.unf.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18226157899370904914&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-north-florida-unf",
      "poi_latitude": "30.2661204",
      "poi_longitude": "-81.50723140000001",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 904-620-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d6a5-75ec-adde-378b177bc8aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d6a5-75ec-adde-378b177bc8aa",
        "storage_key": "property/5134493690101760/019f150a-d6a5-75ec-adde-378b177bc8aa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU2DTHbRK5IgRUr0uDAtS8Pw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_4dc060cb9f5d2a0465614c9d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Ascension St. Vincent's Southside Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4201 Belfort Rd, Jacksonville, FL 32216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-6f35-724c-97be-3348191de176.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-6f35-724c-97be-3348191de176",
        "storage_key": "property/5134493690101760/019f150c-6f35-724c-97be-3348191de176.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/florida/fljac/jacksonville-ascension-st-vincents-southside?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=14571536335466991100&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ascension-st-vincents-southside-hospital",
      "poi_latitude": "30.2537768",
      "poi_longitude": "-81.5818216",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 904-296-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66d-7581-ad77-0453705a1673.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66d-7581-ad77-0453705a1673",
        "storage_key": "property/5134493690101760/019f150a-d66d-7581-ad77-0453705a1673.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVVVXm35YgR_A01Axh_OMo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_657abd30c18029d8656630ed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "HQ Deerwood Park",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10151 Deerwood Park Blvd 200, Suite 250, Jacksonville, FL 32256, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-95ef-7398-9948-cd288518cd83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-95ef-7398-9948-cd288518cd83",
        "storage_key": "property/5134493690101760/019f150c-95ef-7398-9948-cd288518cd83.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hq.com/en/united-states/florida/jacksonville?utm_source=google_uberall&utm_medium=places&utm_campaign=uberall&utm_content=uberall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6261729062532036861&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hq-deerwood-park",
      "poi_latitude": "30.2422445",
      "poi_longitude": "-81.54979870000001",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 904-642-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66c-76fc-8edd-939ac8d3841e",
        "storage_key": "property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-XHPko_K5YgR_Tj2A2gh5lY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "real_estate_agency"
    },
    {
      "id": "ec_e256d6f5a32e93e38a0fb603",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Mayo Clinic",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4500 San Pablo Rd S, Jacksonville, FL 32224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-9296-7366-88f8-513deee06078.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-9296-7366-88f8-513deee06078",
        "storage_key": "property/5134493690101760/019f150c-9296-7366-88f8-513deee06078.webp",
        "width": 929,
        "height": 523
      },
      "poi_business_url": "http://www.mayoclinic.org/patient-visitor-guide/florida/campus-buildings-maps/mayo-building-hospital?mc_id=us&utm_source=yext&utm_medium=l&utm_content=feature&utm_campaign=mayoclinic&geo=national&placementsite=enterprise&invsrc=other&cauid=102372&y_source=1_MzkxODQ2OS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2898705910926404099&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mayo-clinic",
      "poi_latitude": "30.2640897",
      "poi_longitude": "-81.4409507",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "4 hours 3 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 904-953-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66d-7581-ad77-0453705a1673.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66d-7581-ad77-0453705a1673",
        "storage_key": "property/5134493690101760/019f150a-d66d-7581-ad77-0453705a1673.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJk5xKnQ3K5YgRA-oXAatFOig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_50cda08bcdcc52e75663f49a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "FIS",
      "poi_type": "Major Employers & Offices",
      "poi_address": "347 Riverside Ave, Jacksonville, FL 32204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-93ad-7206-ad11-69324f1542e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-93ad-7206-ad11-69324f1542e7",
        "storage_key": "property/5134493690101760/019f150c-93ad-7206-ad11-69324f1542e7.webp",
        "width": 884,
        "height": 584
      },
      "poi_business_url": "https://www.fisglobal.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5382664508797814060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fis",
      "poi_latitude": "30.3210514",
      "poi_longitude": "-81.6730915",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 904-438-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66c-76fc-8edd-939ac8d3841e",
        "storage_key": "property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPwoIH3K35YgRLAX_J9oQs0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_734433f00f81b05ccf20f1ab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "CSX Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 Water St #4445, Jacksonville, FL 32202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-9417-736b-8c58-56fcb088c7de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-9417-736b-8c58-56fcb088c7de",
        "storage_key": "property/5134493690101760/019f150c-9417-736b-8c58-56fcb088c7de.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.csx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12013208524298938918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "csx-corporation",
      "poi_latitude": "30.3242164",
      "poi_longitude": "-81.6640066",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 37 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 904-359-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66c-76fc-8edd-939ac8d3841e",
        "storage_key": "property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBcgd-RO35YgRJmqID4F9t6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_6d49c770a792df2fa586eea2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "Fidelity National Financial, Inc.,",
      "poi_type": "Major Employers & Offices",
      "poi_address": "601 Riverside Ave, Jacksonville, FL 32204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-9796-75f4-8365-c21d51084e1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-9796-75f4-8365-c21d51084e1f",
        "storage_key": "property/5134493690101760/019f150c-9796-75f4-8365-c21d51084e1f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://fnf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13143049889862239148&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fidelity-national-financial-inc",
      "poi_latitude": "30.3193076",
      "poi_longitude": "-81.674285",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 41 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 888-934-3354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66c-76fc-8edd-939ac8d3841e",
        "storage_key": "property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYVFYo3G35YgRrMN5bj1-ZbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "insurance_agency"
    },
    {
      "id": "ec_79793746203e87c206b2972e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "JAXPORT Corporate Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2831 Talleyrand Ave, Jacksonville, FL 32206, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-9451-7238-b4ca-74b3b2e15d21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-9451-7238-b4ca-74b3b2e15d21",
        "storage_key": "property/5134493690101760/019f150c-9451-7238-b4ca-74b3b2e15d21.webp",
        "width": 502,
        "height": 313
      },
      "poi_business_url": "http://www.jaxport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8978070890287588599&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jaxport-corporate-headquarters",
      "poi_latitude": "30.3562351",
      "poi_longitude": "-81.6249954",
      "poi_miles_from_property": "12.5 mi",
      "poi_walking_minutes": "4 hours 31 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 904-357-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-a342-7428-b3e0-10d72d5b8532.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-a342-7428-b3e0-10d72d5b8532",
        "storage_key": "property/5134493690101760/019f150c-a342-7428-b3e0-10d72d5b8532.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJadHjj-Cy5YgR9-TdJ-iDmHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_463e4bb680af6d8d196cb486",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "poi_name": "The Winn-Dixie Company Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5050 Edgewood Ct, Jacksonville, FL 32254, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150c-978c-707b-9ecd-33a50ecde3d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-978c-707b-9ecd-33a50ecde3d5",
        "storage_key": "property/5134493690101760/019f150c-978c-707b-9ecd-33a50ecde3d5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.winndixie.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11813128737945114461&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-winn-dixie-company-headquarters",
      "poi_latitude": "30.3235416",
      "poi_longitude": "-81.7334585",
      "poi_miles_from_property": "13.7 mi",
      "poi_walking_minutes": "5 hours 7 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 904-783-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-d66c-76fc-8edd-939ac8d3841e",
        "storage_key": "property/5134493690101760/019f150a-d66c-76fc-8edd-939ac8d3841e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4VXt7ae55YgRXVctn_-p8KM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_985e533b-784c-4cdf-af7e-15c371972480",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_14e43ec6-56d9-4731-9e39-4e7af20fae8a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_ad398acc-ddf9-401e-af67-85b065eef688",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_6f70d7db-a4e0-43c1-8efa-7d38dce2df22",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d6028cb4-3cae-4405-b955-8d7f0034cf43",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c8230981-61b1-4a3b-bb9b-05953f323de1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_70f8f364-572a-489a-929a-354d01b4ebc0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "rating": "5.0",
      "name": "Angeliz Rosado",
      "text": "I want to express my sincere appreciation for everything that Monica and Toran have done to support us. Their professionalism, responsiveness, and genuine care for the residents have truly made a difference in our experience here. I also want to recognize the maintenance staff, who have been outstanding in every way. They consistently go above and beyond to address any issues promptly, maintain the property to a high standard, and ensure that our community remains a clean, safe, and welcoming place to live. Their hard work and dedication do not go unnoticed, and we are truly grateful for all that they do.",
      "date": "2025-10-17",
      "title": ""
    },
    {
      "id": "custom_db82cb7e-b7c1-43f9-8fba-c34c4aac38fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "rating": "5.0",
      "name": "j wils",
      "text": "I want to give a huge thank you to our apartment maintenance team, Enver and George  for their outstanding service and incredibly fast response. After submitting a service request for an AC cooling issue, the team responded almost immediately, quickly diagnosed the problem, and replaced a major component of the air conditioning unit — all within about 30 minutes.\n\nTheir professionalism, technical expertise, and sense of urgency were truly impressive. It’s rare to experience such efficient and high-quality maintenance service, and I genuinely appreciate how smoothly and quickly everything was handled. Thanks again for going above and beyond to make sure the issue was fully resolved so quickly!",
      "date": "2026-05-15",
      "title": ""
    },
    {
      "id": "custom_7f88f74e-940f-4951-9629-c8583e19fd30",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "rating": "5.0",
      "name": "william cornell",
      "text": "I have been a resident here for 3 years and Monica is amazing. Any issues and she is taking care of it as fast as she could. I can say the community is quiet and the apartments are spacious. Has been a great pleasure being here",
      "date": "2026-01-16",
      "title": ""
    },
    {
      "id": "custom_070a8570-93a1-4591-9aeb-a28062ac69af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "rating": "5.0",
      "name": "Ted Carter",
      "text": "Deerwood Eddison Apartments is an amazing place to live! The community is clean, quiet, and beautifully maintained, with great amenities and a convenient location. The real highlight, though, is Rob Vidler—he’s the best leasing agent ever. Rob made the entire process easy and stress-free, answering every question and going above and beyond to help find the perfect apartment. He’s professional, friendly, and always quick to respond, even after move-in. Thanks to Rob and the great team, living here has been a wonderful experience. Highly recommend Deerwood Eddison to anyone looking for a new home!",
      "date": "2026-02-26",
      "title": ""
    },
    {
      "id": "custom_4b2466cb-4cba-46cc-8095-d4e365f62453",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "rating": "5.0",
      "name": "Anthony Hebert",
      "text": "I love this place! New mgmt so don't let older reviews fool you. My neighbors are quiet and friendly; the amenities are amazing. The gym is actually better than my commercial gym. All of my maintenance requests have been handled quickly and properly. I definitely highly recommend!",
      "date": "2025-11-05",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_6a55f4ec2ed6e37ca3b0d56c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f14c4-58b3-746a-bf57-038bdc566472.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-58b3-746a-bf57-038bdc566472",
        "storage_key": "property/5134493690101760/019f14c4-58b3-746a-bf57-038bdc566472.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1,245SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=eJWJt3Aup16"
    },
    {
      "id": "ec_6933acba9c07cecda3138160",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f14c4-56b0-71c7-8ab7-4eb6dfc402c8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-56b0-71c7-8ab7-4eb6dfc402c8",
        "storage_key": "property/5134493690101760/019f14c4-56b0-71c7-8ab7-4eb6dfc402c8.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Eddison at Deerwood Park Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/FTqfUdtlSNo"
    },
    {
      "id": "ec_172527273c6e0b426d902cb9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019d02ee-cdbe-7478-baea-5ada8accc2af.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Gym with treadmills, stationary bikes, and weight machines",
        "public_id": "019d02ee-cdbe-7478-baea-5ada8accc2af",
        "storage_key": "property/5134493690101760/019d02ee-cdbe-7478-baea-5ada8accc2af.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Ax1h6iPo4Tc"
    },
    {
      "id": "ec_1e675e297647c2acdb1a8174",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f14c4-5ed4-7699-b524-2231f76451f4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-5ed4-7699-b524-2231f76451f4",
        "storage_key": "property/5134493690101760/019f14c4-5ed4-7699-b524-2231f76451f4.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=mJhbnMepuZL"
    },
    {
      "id": "ec_bee7de7e3e3f5f6406581a6d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f14c4-5ffd-70fe-b732-1c87554cb993.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-5ffd-70fe-b732-1c87554cb993",
        "storage_key": "property/5134493690101760/019f14c4-5ffd-70fe-b732-1c87554cb993.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Media Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=x6wAi7LRmEj"
    }
  ],
  "faqs": [
    {
      "id": "custom_cd87ee82-3042-4d58-9fd6-dc46851d94f5",
      "question": "Is Eddison at Deerwood Park pet-friendly?",
      "answer": "Yes. Eddison at Deerwood Park welcomes cats and dogs, up to 2 pets per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For the full pet policy, call the leasing team at (904) 996-0034 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_17357e67-67ff-4efe-b5c6-6ed330a6c9df",
      "question": "How can I schedule a tour at Eddison at Deerwood Park?",
      "answer": "You can schedule a tour of Eddison at Deerwood Park online through our Schedule a Tour page, or call the leasing office at (904) 996-0034. You can also view our virtual tours to see the community before visiting in person.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_8fd216e7-2bf9-44fe-ad3f-8750fb4045d5",
      "question": "What are the leasing office hours at Eddison at Deerwood Park?",
      "answer": "The Eddison at Deerwood Park leasing office is open during these hours:\n\n• Monday: 9:00 AM to 6:00 PM\n• Tuesday: 9:00 AM to 6:00 PM\n• Wednesday: 9:00 AM to 6:00 PM\n• Thursday: 9:00 AM to 6:00 PM\n• Friday: 9:00 AM to 6:00 PM\n• Saturday: 10:00 AM to 5:00 PM\n\nHours may change around holidays. Call (904) 996-0034 or visit our contact page to confirm before you visit.",
      "category": "Office Hours",
      "source": "custom"
    },
    {
      "id": "custom_208d064b-078f-447f-8b58-585c7c0676db",
      "question": "What floor plans are available at Eddison at Deerwood Park?",
      "answer": "Eddison at Deerwood Park offers 1- to 3-bedroom apartment homes ranging from approximately 711 to 1,550 square feet, across 10 floor plans. View layouts, square footage, and current availability on our Floor Plans page, or schedule a tour to see them in person.",
      "category": "Floor Plans & Units",
      "source": "custom"
    },
    {
      "id": "custom_64450f74-5379-4363-83d7-6520999fad5f",
      "question": "What amenities does Eddison at Deerwood Park have?",
      "answer": "Eddison at Deerwood Park offers a range of community and in-home amenities. Community amenities include: LUXER Package Locker, Access Gates, American Landmark 360, Car Wash, Coffee Bar, Dog Park, Fitness Center, Garages, Online Resident Services, Outdoor Kitchen, Pool, Select Homes, Volleyball Court, Yoga Room, and Lounge. In-home features include: built-in microwave, crown molding, garden tub, hard floors, kitchen appliances, outside space, sunroom, tile backsplash, usb outlet, w&d included, and storage units. See the complete list on our Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_fd9f948a-1f19-4ab8-bc52-4ffcb42fad04",
      "question": "Where is Eddison at Deerwood Park located?",
      "answer": "Eddison at Deerwood Park is located at 4435 Touchton Rd, Jacksonville FL 32246. Nearby you'll find dining at Deerwood Bistro, shopping at Publix Super Market at St. John's Town Center, and green space at Deerwood Rotary Childrens Park. Explore more on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_2ff93411-3f05-4efb-aacf-33d78223bcaf",
      "question": "How do I apply to live at Eddison at Deerwood Park?",
      "answer": "You can apply to live at Eddison at Deerwood Park online through our Apply Now page, which walks you through each step. If you have questions, the leasing team can help. Call (904) 996-0034 or reach out through our contact page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_0282eb5e-efdd-49a8-8415-59cdf1228745",
      "question": "What do I need to apply at Eddison at Deerwood Park?",
      "answer": "Applicants should be ready to provide standard rental application information, including government-issued identification, proof of income, and rental history. Qualification requirements can vary, so we recommend confirming the current criteria with the Eddison at Deerwood Park leasing team at (904) 996-0034 or on our contact page. When you're ready, start on the Apply Now page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_4429fc59-844e-4da1-a69e-742b7116fbab",
      "question": "What is the Landmark 360 program at Eddison at Deerwood Park?",
      "answer": "Eddison at Deerwood Park participates in American Landmark's Landmark 360 resident program, which includes three resident promises:\n\n• Move-In Satisfaction Promise: if you are not satisfied within your first 15 days, American Landmark will refund your deposit and waive lease-termination fees.\n• 48-Hour Maintenance Completion Promise: work orders are completed within 48 hours (Monday through Friday), with rent credits if that timeline is missed.\n• Relocation Promise: after six months on your lease, you can transfer to another American Landmark community without penalties, with 60 days' written notice.\nTo learn more, contact the leasing team at (904) 996-0034 or visit our contact page.",
      "category": "Resident Programs",
      "source": "custom"
    },
    {
      "id": "custom_07dc5977-2159-40c1-9267-2180e8dbf319",
      "question": "Does Eddison at Deerwood Park have a pool?",
      "answer": "Yes. Eddison at Deerwood Park has a swimming pool for residents. See it alongside our other community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_932ef64b-27c1-445e-9699-d493011531bd",
      "question": "Does Eddison at Deerwood Park have a fitness center?",
      "answer": "Yes. Eddison at Deerwood Park has a fitness center for residents. See all amenities on the Amenities page, or schedule a tour to view it in person.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_abb86566-f88e-4488-81ae-778832ef5bcd",
      "question": "Does Eddison at Deerwood Park have a dog park?",
      "answer": "Yes. Eddison at Deerwood Park has an on-site dog park for residents and their dogs. See more community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_49d957cd-1ffd-409b-a48f-119dc86bef04",
      "question": "Does Eddison at Deerwood Park offer virtual tours?",
      "answer": "Yes. Eddison at Deerwood Park offers virtual tours of 2BR, 2BA - 1,245SF, Eddison at Deerwood Park Community Tour, Fitness Center, Clubhouse, and Media Center. Start on our Virtual Tours page, then schedule an in-person tour when you are ready.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_c4443bb0-01b2-4207-ab0b-927dcb71ffc8",
      "question": "What do residents say about living at Eddison at Deerwood Park?",
      "answer": "Residents frequently mention the helpful staff and responsive maintenance at Eddison at Deerwood Park. One resident wrote: *\"I have been a resident here for 3 years and Monica is amazing. Any issues and she is taking care of it as fast as she could. I can say the community is quiet and the apartments are spacious. Has been a great pleasure being here\"* Read more resident reviews on our Reviews page.",
      "category": "Resident Life",
      "source": "custom"
    },
    {
      "id": "custom_f68f7c09-6098-44dc-bffd-7ece80fa6e8e",
      "question": "When was Eddison at Deerwood Park built?",
      "answer": "Eddison at Deerwood Park was built in 2001 and renovated in 2020. Schedule a tour to see the finishes in person.",
      "category": "Property History & Features",
      "source": "custom"
    },
    {
      "id": "custom_0bafc1fc-7756-4130-9697-2deb58f35438",
      "question": "What is the pet fee at Eddison at Deerwood Park?",
      "answer": "Pets at Eddison at Deerwood Park: cats and dogs are welcome, up to 2 per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For details, contact the leasing team at (904) 996-0034 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_9472bddd-cdcf-4476-ac14-6153e1b8822e",
      "question": "What features are included in the apartments at Eddison at Deerwood Park?",
      "answer": "Apartment homes at Eddison at Deerwood Park include built-in microwave, crown molding, garden tub, hard floors, kitchen appliances, outside space, sunroom, tile backsplash, usb outlet, w&d included, and storage units. Browse layouts on our Floor Plans page or schedule a tour.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_6ae46b25-d942-495e-adc2-4fb44130e6bd",
      "question": "What restaurants and shops are near Eddison at Deerwood Park?",
      "answer": "Nearby restaurants and shops include Deerwood Bistro, THE LOOP RESTAURANT, Miller's Ale House, and Cantina Louie (Jacksonville/Southside, FL). See the full neighborhood guide on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-64ee-7764-b62c-66e471337d98",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "eddison-at-deerwood-park",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760"
    },
    {
      "lead_collector_id": "0198aa45-6551-753b-8a1d-364486a438ff",
      "lead_source": "FACEBOOK_ADS",
      "name": "eddison-at-deerwood-park",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760"
    },
    {
      "lead_collector_id": "0198aa45-65b5-762d-86d4-51e47895ac25",
      "lead_source": "LANDING_PAGE",
      "name": "eddison-at-deerwood-park",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "page_item_url": "discover-one-bedroom-apartments-for-rent-jacksonville-fl",
      "search_query": "One Bedroom Apartments For Rent In Jacksonville FL",
      "category": "Floorplan",
      "h1_title": "Discover One Bedroom Apartments For Rent In Jacksonville FL",
      "h2_subtitle": "Eddison at Deerwood Park offers modern, stylish living in Jacksonville. Enjoy resort-inspired amenities and a prime location in Windy Hill.",
      "page_copy": "Welcome to Eddison at Deerwood Park, where you can find one bedroom apartments for rent in Jacksonville FL that redefine modern living. Our community features spacious, pet-friendly homes with stylish accents and a host of perks designed to elevate your lifestyle. Each apartment is equipped with stainless steel appliances, hardwood floors, and walk-in closets, ensuring comfort and convenience.\n\nBeyond your doorstep, indulge in our upscale amenities, including a resort-inspired swimming pool, fitness center, and dog park. Our prime location in Windy Hill places you near Jacksonville's best attractions, making Eddison at Deerwood Park the perfect place to call home. Experience the blend of luxury and convenience with our one bedroom apartments for rent in Jacksonville FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, green accent wall, and patio access.",
        "public_id": "019f6c0e-5f4c-7533-8538-eb3b9c027602",
        "storage_key": "property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-68f1-727e-8e58-80eeb9832c74",
        "storage_key": "property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Eddison at Deerwood Park | One Bedroom Apartments For Rent In Jacksonville FL",
      "seo_description": "Explore Eddison at Deerwood Park for one bedroom apartments for rent in Jacksonville FL. Enjoy modern living with resort-inspired amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "page_item_url": "explore-two-bedrooms-apartments-for-rent-jacksonville-fl",
      "search_query": "Two Bedrooms Apartments For Rent In Jacksonville FL",
      "category": "Floorplan",
      "h1_title": "Explore Two Bedrooms Apartments For Rent In Jacksonville FL",
      "h2_subtitle": "Eddison at Deerwood Park offers spacious two-bedroom apartments in Jacksonville. Enjoy luxurious amenities and a prime location in Windy Hill.",
      "page_copy": "At Eddison at Deerwood Park, discover two bedrooms apartments for rent in Jacksonville FL that offer a perfect blend of style and comfort. Our community features spacious, pet-friendly homes with modern accents and a variety of perks to enhance your living experience. Each apartment includes stainless steel appliances, hardwood floors, and walk-in closets, providing a luxurious and convenient lifestyle.\n\nStep outside your apartment to enjoy our resort-inspired amenities, such as a swimming pool, fitness center, and dog park. Located in the vibrant Windy Hill neighborhood, Eddison at Deerwood Park places you near Jacksonville's top attractions, making it an ideal choice for your next home. Experience the perfect combination of luxury and convenience with our two bedrooms apartments for rent in Jacksonville FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, green accent wall, and patio access.",
        "public_id": "019f6c0e-5f4c-7533-8538-eb3b9c027602",
        "storage_key": "property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-68f1-727e-8e58-80eeb9832c74",
        "storage_key": "property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Eddison at Deerwood Park | Two Bedrooms Apartments For Rent In Jacksonville FL",
      "seo_description": "Find two bedrooms apartments for rent in Jacksonville FL at Eddison at Deerwood Park. Enjoy spacious living with luxurious amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "page_item_url": "find-three-bedrooms-apartments-for-rent-jacksonville-fl",
      "search_query": "Three Bedrooms Apartments For Rent In Jacksonville FL",
      "category": "Floorplan",
      "h1_title": "Find Three Bedrooms Apartments For Rent In Jacksonville FL",
      "h2_subtitle": "Eddison at Deerwood Park offers spacious three-bedroom apartments in Jacksonville. Enjoy resort-style amenities and a prime location in Windy Hill.",
      "page_copy": "Discover the perfect home at Eddison at Deerwood Park with our three bedrooms apartments for rent in Jacksonville FL. Our community features spacious, pet-friendly homes with modern accents and a variety of perks to enhance your living experience. Each apartment is equipped with stainless steel appliances, hardwood floors, and walk-in closets, ensuring a luxurious and convenient lifestyle.\n\nEnjoy our resort-inspired amenities, including a swimming pool, fitness center, and dog park, right outside your door. Located in the vibrant Windy Hill neighborhood, Eddison at Deerwood Park places you near Jacksonville's top attractions, making it an ideal choice for your next home. Experience the perfect combination of luxury and convenience with our three bedrooms apartments for rent in Jacksonville FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, green accent wall, and patio access.",
        "public_id": "019f6c0e-5f4c-7533-8538-eb3b9c027602",
        "storage_key": "property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-68f1-727e-8e58-80eeb9832c74",
        "storage_key": "property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Eddison at Deerwood Park | Three Bedrooms Apartments For Rent In Jacksonville FL",
      "seo_description": "Explore three bedrooms apartments for rent in Jacksonville FL at Eddison at Deerwood Park. Enjoy spacious living with luxurious amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-pool",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Pool",
      "h2_subtitle": "Eddison at Deerwood Park offers luxurious apartments with a pool in Jacksonville. Enjoy resort-style living and a prime location in Windy Hill.",
      "page_copy": "Welcome to Eddison at Deerwood Park, where you can find apartments for rent near me with pool that redefine luxury living. Our community features spacious, pet-friendly homes with modern accents and a variety of perks to enhance your lifestyle. Each apartment is designed to provide comfort and convenience, making it the perfect place to call home.\n\nStep outside your apartment to enjoy our resort-inspired swimming pool, fitness center, and dog park. Located in the vibrant Windy Hill neighborhood, Eddison at Deerwood Park places you near Jacksonville's top attractions, ensuring you have everything you need within reach. Experience the perfect combination of luxury and convenience with our apartments for rent near me with pool.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, green accent wall, and patio access.",
        "public_id": "019f6c0e-5f4c-7533-8538-eb3b9c027602",
        "storage_key": "property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-68f1-727e-8e58-80eeb9832c74",
        "storage_key": "property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Eddison at Deerwood Park | Apartments For Rent Near Me with Pool",
      "seo_description": "Find apartments for rent near me with pool at Eddison at Deerwood Park. Enjoy luxurious living with resort-style amenities in a prime Jacksonville location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-me-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Explore Apartments For Rent Near Me with Fitness Center",
      "h2_subtitle": "Eddison at Deerwood Park offers modern apartments with a fitness center in Jacksonville. Enjoy resort-style amenities and a prime location in Windy Hill.",
      "page_copy": "Discover the perfect home at Eddison at Deerwood Park, where you can find apartments for rent near me with fitness center that cater to your active lifestyle. Our community features spacious, pet-friendly homes with stylish accents and a variety of perks to enhance your living experience. Each apartment is designed to provide comfort and convenience, making it the ideal place to call home.\n\nEnjoy our state-of-the-art fitness center, along with other resort-inspired amenities such as a swimming pool and dog park. Located in the vibrant Windy Hill neighborhood, Eddison at Deerwood Park places you near Jacksonville's top attractions, ensuring you have everything you need within reach. Experience the perfect combination of luxury and convenience with our apartments for rent near me with fitness center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, green accent wall, and patio access.",
        "public_id": "019f6c0e-5f4c-7533-8538-eb3b9c027602",
        "storage_key": "property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-68f1-727e-8e58-80eeb9832c74",
        "storage_key": "property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Eddison at Deerwood Park | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Find apartments for rent near me with fitness center at Eddison at Deerwood Park. Enjoy modern living with resort-style amenities in a prime Jacksonville location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-walk-in-closets",
      "search_query": "Apartments For Rent Near Me with Walk-In Closets",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Walk-In Closets",
      "h2_subtitle": "Eddison at Deerwood Park offers spacious apartments with walk-in closets in Jacksonville. Enjoy resort-style amenities and a prime location in Windy Hill.",
      "page_copy": "Welcome to Eddison at Deerwood Park, where you can find apartments for rent near me with walk-in closets that offer ample storage and style. Our community features spacious, pet-friendly homes with modern accents and a variety of perks to enhance your living experience. Each apartment is designed with walk-in closets, providing you with the space and organization you need for a clutter-free lifestyle.\n\nEnjoy our resort-inspired amenities, such as a swimming pool, fitness center, and dog park, right outside your door. Located in the vibrant Windy Hill neighborhood, Eddison at Deerwood Park places you near Jacksonville's top attractions, ensuring you have everything you need within reach. Experience the perfect combination of luxury and convenience with our apartments for rent near me with walk-in closets.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, green accent wall, and patio access.",
        "public_id": "019f6c0e-5f4c-7533-8538-eb3b9c027602",
        "storage_key": "property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-68f1-727e-8e58-80eeb9832c74",
        "storage_key": "property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Eddison at Deerwood Park | Apartments For Rent Near Me with Walk-In Closets",
      "seo_description": "Find apartments for rent near me with walk-in closets at Eddison at Deerwood Park. Enjoy spacious living with resort-style amenities in a prime Jacksonville location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-me-with-balcony-patio",
      "search_query": "Apartments For Rent Near Me with Balcony/Patio",
      "category": "Amenity",
      "h1_title": "Explore Apartments For Rent Near Me with Balcony/Patio",
      "h2_subtitle": "Eddison at Deerwood Park offers modern apartments with balcony/patio in Jacksonville. Enjoy resort-style amenities and a prime location in Windy Hill.",
      "page_copy": "Discover the perfect home at Eddison at Deerwood Park, where you can find apartments for rent near me with balcony/patio that offer outdoor relaxation and style. Our community features spacious, pet-friendly homes with modern accents and a variety of perks to enhance your living experience. Each apartment is designed with a private balcony or patio, providing you with a personal outdoor space to unwind and enjoy the fresh air.\n\nEnjoy our resort-inspired amenities, such as a swimming pool, fitness center, and dog park, right outside your door. Located in the vibrant Windy Hill neighborhood, Eddison at Deerwood Park places you near Jacksonville's top attractions, ensuring you have everything you need within reach. Experience the perfect combination of luxury and convenience with our apartments for rent near me with balcony/patio.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, green accent wall, and patio access.",
        "public_id": "019f6c0e-5f4c-7533-8538-eb3b9c027602",
        "storage_key": "property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-68f1-727e-8e58-80eeb9832c74",
        "storage_key": "property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Eddison at Deerwood Park | Apartments For Rent Near Me with Balcony/Patio",
      "seo_description": "Find apartments for rent near me with balcony/patio at Eddison at Deerwood Park. Enjoy modern living with resort-style amenities in a prime Jacksonville location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-jacksonville-fl-near-hca-hospital",
      "search_query": "Apartments For Rent In Jacksonville FL Near HCA Florida Memorial Hospital",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Jacksonville FL Near HCA Florida Memorial Hospital",
      "h2_subtitle": "Eddison at Deerwood Park offers modern apartments near HCA Florida Memorial Hospital in Jacksonville. Enjoy resort-style amenities and a prime location in Windy Hill.",
      "page_copy": "Welcome to Eddison at Deerwood Park, where you can find apartments for rent in Jacksonville FL near HCA Florida Memorial Hospital. Our community features spacious, pet-friendly homes with modern accents and a variety of perks to enhance your living experience. Each apartment is designed to provide comfort and convenience, making it the perfect place to call home.\n\nEnjoy our resort-inspired amenities, such as a swimming pool, fitness center, and dog park, right outside your door. Located in the vibrant Windy Hill neighborhood, Eddison at Deerwood Park places you near HCA Florida Memorial Hospital, ensuring you have access to comprehensive healthcare services including cardiology, oncology, and more. Experience the perfect combination of luxury and convenience with our apartments for rent in Jacksonville FL near HCA Florida Memorial Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, green accent wall, and patio access.",
        "public_id": "019f6c0e-5f4c-7533-8538-eb3b9c027602",
        "storage_key": "property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-68f1-727e-8e58-80eeb9832c74",
        "storage_key": "property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Eddison at Deerwood Park | Apartments For Rent In Jacksonville FL Near HCA Florida Memorial Hospital",
      "seo_description": "Find apartments for rent in Jacksonville FL near HCA Florida Memorial Hospital at Eddison at Deerwood Park. Enjoy modern living with resort-style amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-jacksonville-near-wolfson-childrens-hospital",
      "search_query": "Apartments For Rent In Jacksonville FL Near Wolfson Children's Hospital: Irazuzta Jose E MD",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Jacksonville FL Near Wolfson Children's Hospital: Irazuzta Jose E MD",
      "h2_subtitle": "Eddison at Deerwood Park offers modern apartments near Wolfson Children's Hospital in Jacksonville. Enjoy resort-style amenities and a prime location in Windy Hill.",
      "page_copy": "Welcome to Eddison at Deerwood Park, where you can find apartments for rent in Jacksonville FL near Wolfson Children's Hospital: Irazuzta Jose E MD. Our community features spacious, pet-friendly homes with modern accents and a variety of perks to enhance your living experience. Each apartment is designed to provide comfort and convenience, making it the perfect place to call home.\n\nEnjoy our resort-inspired amenities, such as a swimming pool, fitness center, and dog park, right outside your door. Located in the vibrant Windy Hill neighborhood, Eddison at Deerwood Park places you near Wolfson Children's Hospital, ensuring you have access to specialized pediatric care. Experience the perfect combination of luxury and convenience with our apartments for rent in Jacksonville FL near Wolfson Children's Hospital: Irazuzta Jose E MD.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, green accent wall, and patio access.",
        "public_id": "019f6c0e-5f4c-7533-8538-eb3b9c027602",
        "storage_key": "property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-68f1-727e-8e58-80eeb9832c74",
        "storage_key": "property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Eddison at Deerwood Park | Apartments For Rent In Jacksonville FL Near Wolfson Children's Hospital: Irazuzta Jose E MD",
      "seo_description": "Find apartments for rent in Jacksonville FL near Wolfson Children's Hospital: Irazuzta Jose E MD at Eddison at Deerwood Park. Enjoy modern living with resort-style amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-jacksonville-university",
      "search_query": "Apartments For Rent In Jacksonville FL Near Jacksonville University",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Jacksonville FL Near Jacksonville University",
      "h2_subtitle": "Eddison at Deerwood Park offers modern apartments near Jacksonville University. Enjoy resort-style amenities and a prime location in Windy Hill.",
      "page_copy": "Welcome to Eddison at Deerwood Park, where you can find apartments for rent in Jacksonville FL near Jacksonville University. Our community features spacious, pet-friendly homes with modern accents and a variety of perks to enhance your living experience. Each apartment is designed to provide comfort and convenience, making it the perfect place to call home.\n\nEnjoy our resort-inspired amenities, such as a swimming pool, fitness center, and dog park, right outside your door. Located in the vibrant Windy Hill neighborhood, Eddison at Deerwood Park places you near Jacksonville University, ensuring you have access to educational opportunities and a vibrant campus life. Experience the perfect combination of luxury and convenience with our apartments for rent in Jacksonville FL near Jacksonville University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, green accent wall, and patio access.",
        "public_id": "019f6c0e-5f4c-7533-8538-eb3b9c027602",
        "storage_key": "property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-68f1-727e-8e58-80eeb9832c74",
        "storage_key": "property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Eddison at Deerwood Park | Apartments For Rent In Jacksonville FL Near Jacksonville University",
      "seo_description": "Find apartments for rent in Jacksonville FL near Jacksonville University at Eddison at Deerwood Park. Enjoy modern living with resort-style amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-fl-state-college",
      "search_query": "Apartments For Rent In Jacksonville FL Near Florida State College at Jacksonville: Kent Campus",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent In Jacksonville FL Near Florida State College at Jacksonville: Kent Campus",
      "h2_subtitle": "Eddison at Deerwood Park offers stylish apartments near Florida State College at Jacksonville: Kent Campus. Enjoy resort-style amenities and a prime location in Windy Hill.",
      "page_copy": "Welcome to Eddison at Deerwood Park, where you can find apartments for rent in Jacksonville FL near Florida State College at Jacksonville: Kent Campus. Our community features spacious, pet-friendly homes with modern accents and a variety of perks to enhance your living experience. Each apartment is designed to provide comfort and convenience, making it the perfect place to call home.\n\nEnjoy our resort-inspired amenities, such as a swimming pool, fitness center, and dog park, right outside your door. Located in the vibrant Windy Hill neighborhood, Eddison at Deerwood Park places you near Florida State College at Jacksonville: Kent Campus, ensuring you have access to educational opportunities and a vibrant campus life. Experience the perfect combination of luxury and convenience with our apartments for rent in Jacksonville FL near Florida State College at Jacksonville: Kent Campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, green accent wall, and patio access.",
        "public_id": "019f6c0e-5f4c-7533-8538-eb3b9c027602",
        "storage_key": "property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-68f1-727e-8e58-80eeb9832c74",
        "storage_key": "property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Eddison at Deerwood Park | Apartments For Rent In Jacksonville FL Near Florida State College at Jacksonville: Kent Campus",
      "seo_description": "Find apartments for rent in Jacksonville FL near Florida State College at Jacksonville: Kent Campus at Eddison at Deerwood Park. Enjoy modern living with resort-style amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-jacksonville-fl-near-edward-waters-university",
      "search_query": "Apartments For Rent In Jacksonville FL Near Edward Waters University",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Jacksonville FL Near Edward Waters University",
      "h2_subtitle": "Eddison at Deerwood Park offers modern apartments near Edward Waters University. Enjoy resort-style amenities and a prime location in Windy Hill.",
      "page_copy": "Welcome to Eddison at Deerwood Park, where you can find apartments for rent in Jacksonville FL near Edward Waters University. Our community features spacious, pet-friendly homes with modern accents and a variety of perks to enhance your living experience. Each apartment is designed to provide comfort and convenience, making it the perfect place to call home.\n\nEnjoy our resort-inspired amenities, such as a swimming pool, fitness center, and dog park, right outside your door. Located in the vibrant Windy Hill neighborhood, Eddison at Deerwood Park places you near Edward Waters University, ensuring you have access to educational opportunities and a vibrant campus life. Experience the perfect combination of luxury and convenience with our apartments for rent in Jacksonville FL near Edward Waters University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, green accent wall, and patio access.",
        "public_id": "019f6c0e-5f4c-7533-8538-eb3b9c027602",
        "storage_key": "property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-68f1-727e-8e58-80eeb9832c74",
        "storage_key": "property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Eddison at Deerwood Park | Apartments For Rent In Jacksonville FL Near Edward Waters University",
      "seo_description": "Find apartments for rent in Jacksonville FL near Edward Waters University at Eddison at Deerwood Park. Enjoy modern living with resort-style amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-in-jacksonville-near-chamberlain-university",
      "search_query": "Apartments For Rent In Jacksonville FL Near Chamberlain University - Jacksonville",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent In Jacksonville FL Near Chamberlain University - Jacksonville",
      "h2_subtitle": "Eddison at Deerwood Park offers stylish apartments near Chamberlain University in Jacksonville. Enjoy resort-style amenities and a prime location in Windy Hill.",
      "page_copy": "Welcome to Eddison at Deerwood Park, where you can find apartments for rent in Jacksonville FL near Chamberlain University - Jacksonville. Our community features spacious, pet-friendly homes with modern accents and a variety of perks to enhance your living experience. Each apartment is designed to provide comfort and convenience, making it the perfect place to call home.\n\nEnjoy our resort-inspired amenities, such as a swimming pool, fitness center, and dog park, right outside your door. Located in the vibrant Windy Hill neighborhood, Eddison at Deerwood Park places you near Chamberlain University, ensuring you have access to educational opportunities and a vibrant campus life. Experience the perfect combination of luxury and convenience with our apartments for rent in Jacksonville FL near Chamberlain University - Jacksonville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, green accent wall, and patio access.",
        "public_id": "019f6c0e-5f4c-7533-8538-eb3b9c027602",
        "storage_key": "property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-68f1-727e-8e58-80eeb9832c74",
        "storage_key": "property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Eddison at Deerwood Park | Apartments For Rent In Jacksonville FL Near Chamberlain University - Jacksonville",
      "seo_description": "Find apartments for rent in Jacksonville FL near Chamberlain University - Jacksonville at Eddison at Deerwood Park. Enjoy modern living with resort-style amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-jacksonville-near-hogan-spring-glen",
      "search_query": "Apartments For Rent In Jacksonville FL Near Hogan-Spring Glen Elementary School",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Jacksonville FL Near Hogan-Spring Glen Elementary School",
      "h2_subtitle": "Eddison at Deerwood Park offers family-friendly apartments near Hogan-Spring Glen Elementary School. Enjoy resort-style amenities and a prime location in Windy Hill.",
      "page_copy": "Welcome to Eddison at Deerwood Park, where you can find apartments for rent in Jacksonville FL near Hogan-Spring Glen Elementary School, just 5.6 km away. Our community is perfect for families looking to reside within the Duval County School District. We offer spacious one, two, and three-bedroom floor plans, each designed with modern accents and plenty of perks to transform your everyday into something special.\n\nEnjoy our resort-inspired amenities, such as a swimming pool, fitness center, and dog park, right outside your door. Located in the vibrant Windy Hill neighborhood, Eddison at Deerwood Park places you close to everything Jacksonville has to offer, including the convenience of being near Hogan-Spring Glen Elementary School. Experience the perfect combination of luxury and family-friendly living with our apartments for rent in Jacksonville FL near Hogan-Spring Glen Elementary School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, green accent wall, and patio access.",
        "public_id": "019f6c0e-5f4c-7533-8538-eb3b9c027602",
        "storage_key": "property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-68f1-727e-8e58-80eeb9832c74",
        "storage_key": "property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Eddison at Deerwood Park | Apartments For Rent In Jacksonville FL Near Hogan-Spring Glen Elementary School",
      "seo_description": "Find family-friendly apartments for rent in Jacksonville FL near Hogan-Spring Glen Elementary School at Eddison at Deerwood Park. Enjoy modern living with resort-style amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-jacksonville-fl-near-river-city",
      "search_query": "Apartments For Rent In Jacksonville FL Near River City Science Academy Innovation (K - 8)",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Jacksonville FL Near River City Science Academy Innovation (K - 8)",
      "h2_subtitle": "Eddison at Deerwood Park offers family-friendly apartments near River City Science Academy Innovation. Enjoy resort-style amenities and a prime location in Windy Hill.",
      "page_copy": "Welcome to Eddison at Deerwood Park, where you can find apartments for rent in Jacksonville FL near River City Science Academy Innovation (K - 8), just 9.0 km away. Our community is ideal for families seeking a home within the STEM-focused River City Science Academy district. We offer spacious one, two, and three-bedroom floor plans, each designed with modern accents and plenty of perks to transform your everyday into something special.\n\nEnjoy our resort-inspired amenities, such as a swimming pool, fitness center, and dog park, right outside your door. Located in the vibrant Windy Hill neighborhood, Eddison at Deerwood Park places you close to everything Jacksonville has to offer, including the convenience of being near River City Science Academy Innovation. Experience the perfect combination of luxury and family-friendly living with our apartments for rent in Jacksonville FL near River City Science Academy Innovation (K - 8).",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, green accent wall, and patio access.",
        "public_id": "019f6c0e-5f4c-7533-8538-eb3b9c027602",
        "storage_key": "property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-68f1-727e-8e58-80eeb9832c74",
        "storage_key": "property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Eddison at Deerwood Park | Apartments For Rent In Jacksonville FL Near River City Science Academy Innovation (K - 8)",
      "seo_description": "Find family-friendly apartments for rent in Jacksonville FL near River City Science Academy Innovation (K - 8) at Eddison at Deerwood Park. Enjoy modern living with resort-style amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-jacksonville-fl-near-englewood-high",
      "search_query": "Apartments For Rent In Jacksonville FL Near Englewood High School",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Jacksonville FL Near Englewood High School",
      "h2_subtitle": "Eddison at Deerwood Park offers family-friendly apartments near Englewood High School. Enjoy resort-style amenities and a prime location in Windy Hill.",
      "page_copy": "Welcome to Eddison at Deerwood Park, where you can find apartments for rent in Jacksonville FL near Englewood High School, just 8.6 km away. Our community is perfect for families looking to reside within the Englewood High School district. We offer spacious one, two, and three-bedroom floor plans, each designed with modern accents and plenty of perks to transform your everyday into something special.\n\nEnjoy our resort-inspired amenities, such as a swimming pool, fitness center, and dog park, right outside your door. Located in the vibrant Windy Hill neighborhood, Eddison at Deerwood Park places you close to everything Jacksonville has to offer, including the convenience of being near Englewood High School. Experience the perfect combination of luxury and family-friendly living with our apartments for rent in Jacksonville FL near Englewood High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, green accent wall, and patio access.",
        "public_id": "019f6c0e-5f4c-7533-8538-eb3b9c027602",
        "storage_key": "property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-68f1-727e-8e58-80eeb9832c74",
        "storage_key": "property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Eddison at Deerwood Park | Apartments For Rent In Jacksonville FL Near Englewood High School",
      "seo_description": "Find family-friendly apartments for rent in Jacksonville FL near Englewood High School at Eddison at Deerwood Park. Enjoy modern living with resort-style amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-jacksonville-fl-near-duval-school",
      "search_query": "Apartments For Rent In Jacksonville FL Near Duval Charter School at Southside K-8",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent In Jacksonville FL Near Duval Charter School at Southside K-8",
      "h2_subtitle": "Eddison at Deerwood Park offers family-friendly apartments near Duval Charter School at Southside K-8. Enjoy resort-style amenities and a prime location in Windy Hill.",
      "page_copy": "Welcome to Eddison at Deerwood Park, where you can find apartments for rent in Jacksonville FL near Duval Charter School at Southside K-8, just 4.7 km away. Our community is ideal for families seeking a home within the Duval Charter School district. We offer spacious one, two, and three-bedroom floor plans, each designed with modern accents and plenty of perks to transform your everyday into something special.\n\nEnjoy our resort-inspired amenities, such as a swimming pool, fitness center, and dog park, right outside your door. Located in the vibrant Windy Hill neighborhood, Eddison at Deerwood Park places you close to everything Jacksonville has to offer, including the convenience of being near Duval Charter School at Southside K-8. Experience the perfect combination of luxury and family-friendly living with our apartments for rent in Jacksonville FL near Duval Charter School at Southside K-8.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, green accent wall, and patio access.",
        "public_id": "019f6c0e-5f4c-7533-8538-eb3b9c027602",
        "storage_key": "property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-68f1-727e-8e58-80eeb9832c74",
        "storage_key": "property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Eddison at Deerwood Park | Apartments For Rent In Jacksonville FL Near Duval Charter School at Southside K-8",
      "seo_description": "Find family-friendly apartments for rent in Jacksonville FL near Duval Charter School at Southside K-8 at Eddison at Deerwood Park. Enjoy modern living with resort-style amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-twin-lakes-academy",
      "search_query": "Apartments For Rent In Jacksonville FL Near Twin Lakes Academy Middle School",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Jacksonville FL Near Twin Lakes Academy Middle School",
      "h2_subtitle": "Eddison at Deerwood Park offers family-friendly apartments near Twin Lakes Academy Middle School. Enjoy resort-style amenities and a prime location in Windy Hill.",
      "page_copy": "Welcome to Eddison at Deerwood Park, where you can find apartments for rent in Jacksonville FL near Twin Lakes Academy Middle School, just 8.6 km away. Our community is perfect for families looking to reside within the Duval County School District. We offer spacious one, two, and three-bedroom floor plans, each designed with modern accents and plenty of perks to transform your everyday into something special.\n\nEnjoy our resort-inspired amenities, such as a swimming pool, fitness center, and dog park, right outside your door. Located in the vibrant Windy Hill neighborhood, Eddison at Deerwood Park places you close to everything Jacksonville has to offer, including the convenience of being near Twin Lakes Academy Middle School. Experience the perfect combination of luxury and family-friendly living with our apartments for rent in Jacksonville FL near Twin Lakes Academy Middle School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, green accent wall, and patio access.",
        "public_id": "019f6c0e-5f4c-7533-8538-eb3b9c027602",
        "storage_key": "property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-68f1-727e-8e58-80eeb9832c74",
        "storage_key": "property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Eddison at Deerwood Park | Apartments For Rent In Jacksonville FL Near Twin Lakes Academy Middle School",
      "seo_description": "Find family-friendly apartments for rent in Jacksonville FL near Twin Lakes Academy Middle School at Eddison at Deerwood Park. Enjoy modern living with resort-style amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-jacksonville-fl-near-law-school",
      "search_query": "Apartments For Rent In Jacksonville FL Near Florida Coastal School of Law",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Jacksonville FL Near Florida Coastal School of Law",
      "h2_subtitle": "Eddison at Deerwood Park offers a prime location in Southside Jacksonville, FL. Enjoy spacious living with our 1, 2, and 3 bedroom floor plans.",
      "page_copy": "Eddison at Deerwood Park features apartments for rent in Jacksonville, FL, near Florida Coastal School of Law, providing an ideal living space for students and professionals alike. Located in the vibrant Southside area, our community is just minutes away from the bustling St. Johns Town Center, offering a variety of shopping, dining, and entertainment options. \n\nOur spacious 1, 2, and 3 bedroom floor plans are designed to meet your lifestyle needs, with modern amenities and stylish interiors. Whether you're a student at Florida Coastal School of Law or a professional seeking a convenient location, Eddison at Deerwood Park is the perfect place to call home. Schedule a tour today and experience the best of Jacksonville living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, green accent wall, and patio access.",
        "public_id": "019f6c0e-5f4c-7533-8538-eb3b9c027602",
        "storage_key": "property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-68f1-727e-8e58-80eeb9832c74",
        "storage_key": "property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Eddison at Deerwood Park | Apartments For Rent In Jacksonville FL Near Florida Coastal School of Law",
      "seo_description": "Explore Eddison at Deerwood Park's apartments for rent in Jacksonville, FL, near Florida Coastal School of Law. Spacious floor plans and prime location await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5134493690101760",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-jacksonville-fl-near-touchton-plaza",
      "search_query": "Apartments For Rent In Jacksonville FL Near Touchton Plaza",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Jacksonville FL Near Touchton Plaza",
      "h2_subtitle": "Eddison at Deerwood Park offers a prime location in Southside Jacksonville. Enjoy spacious living with easy access to St. Johns Town Center and more.",
      "page_copy": "Eddison at Deerwood Park features a variety of spacious 1, 2, and 3 bedroom floor plans, perfect for anyone looking for apartments for rent in Jacksonville FL near Touchton Plaza. Located at 4435 Touchton Road, our community provides residents with convenient access to the vibrant shopping and dining options at St. Johns Town Center. \n\nExperience the best of Jacksonville living with our modern amenities and beautifully landscaped grounds. Whether you're relaxing at home or exploring the nearby attractions, Eddison at Deerwood Park is the ideal place to call home. Schedule a tour today and see why our apartments for rent in Jacksonville FL near Touchton Plaza are the perfect choice for your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, green accent wall, and patio access.",
        "public_id": "019f6c0e-5f4c-7533-8538-eb3b9c027602",
        "storage_key": "property/5134493690101760/019f6c0e-5f4c-7533-8538-eb3b9c027602.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-68f1-727e-8e58-80eeb9832c74",
        "storage_key": "property/5134493690101760/019f6c0e-68f1-727e-8e58-80eeb9832c74.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Eddison at Deerwood Park | Apartments For Rent In Jacksonville FL Near Touchton Plaza",
      "seo_description": "Explore Eddison at Deerwood Park for apartments for rent in Jacksonville FL near Touchton Plaza. Spacious floor plans and prime location await you. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2156"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376470957"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a29\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a29\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4717196"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TDQLXRW"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443209785"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "aabd5c7ed21511f1"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/6m9pzgy2vk1"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/fad6d59d-0e33-42e0-a1db-4470010f221c"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "904-977-3133"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImNZTXlkczF6VXdzV2Q4aC9rU254UWc9PSIsInZhbHVlIjoiMmZFenpQQkxwZ24zNksyZjhLQkJnZz09IiwibWFjIjoiNGE1MDEyYjc4MjhjOGY4ZDQ4MjQ5NWQ2YjMzNjI2MWZmNDQ1MzU3OTYzZDdjNTAxNGM2MWE1OGQxYjVjYjQxZSJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2156",
  "custom_repli_id": "2376470957",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a29\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a29\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4717196",
  "custom_google_gtm_id": "GTM-TDQLXRW",
  "custom_rollout_phase": "1",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443209785",
  "custom_knock_community_id": "aabd5c7ed21511f1",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/6m9pzgy2vk1",
  "custom_self_guided_tour_url": "https://selftournow.com/property/fad6d59d-0e33-42e0-a1db-4470010f221c",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "904-977-3133",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImNZTXlkczF6VXdzV2Q4aC9rU254UWc9PSIsInZhbHVlIjoiMmZFenpQQkxwZ24zNksyZjhLQkJnZz09IiwibWFjIjoiNGE1MDEyYjc4MjhjOGY4ZDQ4MjQ5NWQ2YjMzNjI2MWZmNDQ1MzU3OTYzZDdjNTAxNGM2MWE1OGQxYjVjYjQxZSJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "be82873e-0594-4a7d-a996-f557babf5735",
  "custom_audioeye_site_hash": "3c03cb85b698403bc417f78434adb04d"
};

export const generatedAt = '2026-11-03T20:36:49.817Z';
